<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Simulasi Gadai</h5>
            </template>
          
            <div class="form-content-wrapper">
                <b-alert show variant="warning">
                <i class="fa fa-exclamation-triangle mr-2"></i>
                    Harap mengisi data Anggota terlebih dahulu jika ingin melakukan simulasi gadai BPKB
                </b-alert>
                    <h6 class="form-title">DATA ANGGOTA</h6>
                    <div class="mb-4">
                        <b-button @click="openSearchAnggotaModal" name="modalSearchAnggotaBtn" variant="pgiBtn" class="mr-2">
                          <i class="fa fa-search mr-2"></i>Pilih Anggota
                        </b-button>
                    </div>

                    <div class="flex detail-container md:flex-row md:items-start w-full gap-4">
                        <!-- Detail Data Anggota -->
                        <div class="detail-data flex-1" style="flex:0.7">
                            <b-row class="mb-2">
                                <b-col cols="4" class="detail-data-label">No. Anggota</b-col>
                                <b-col>
                                    <strong>{{ anggota.no }}</strong> 
                                    <span v-if="anggota.statusPembayaran != null && anggota.statusPembayaran == 1" 
                                        class="badge badge-success ml-2 text-sm">
                                        Lancar
                                    </span>
                                </b-col>
                            </b-row>
                            <b-row class="mb-2">
                                <b-col cols="4" class="detail-data-label">No. Member</b-col>
                                <b-col v-if="anggota.noMember != null"><strong>{{ anggota.noMember }}</strong></b-col>
                                <b-col v-else>-</b-col>
                            </b-row>

                            <template v-for="(item, i) in anggota.identitas">
                                <b-row :key="i" class="mb-1">
                                    <b-col cols="4" class="detail-data-label" v-if="i === 0">Jenis Identitas</b-col>
                                    <b-col cols="4" v-else></b-col>
                                    <b-col cols="8">{{i+1 + ") " +item.jenisIdentitas }} - {{ item.noIdentitas }}<a @click="openPreview(item.fotoIdentitas)" style="cursor:pointer; font-weight:bold; color:#1e73be"> (Lihat Foto)</a></b-col>
                                </b-row>
                            </template>
                            <!-- <b-row class="mb-2">
                                <b-col cols="4" class="detail-data-label">Jenis Identitas</b-col>
                                <b-col>{{ anggota.jenisIdentitas }}</b-col>
                            </b-row>
                            <b-row class="mb-2">
                                <b-col cols="4" class="detail-data-label">No. Identitas</b-col>
                                <b-col>{{ anggota.noIdentitas }}</b-col>
                            </b-row> -->
                            <b-row class="mb-2">
                                <b-col cols="4" class="detail-data-label">Nama</b-col>
                                <b-col>{{ anggota.nama }}</b-col>
                            </b-row>
                            <b-row class="mb-2">
                                <b-col cols="4" class="detail-data-label">No. HP</b-col>
                                <b-col>
                                    <div class="wrapper-whatsapp-detail">
                                        <span>
                                            {{ anggota.noHp }}
                                        </span>
                                        <template v-if="anggota.noHp && anggota.noHp !== '-'">
                                            <b-button
                                                size="sm" variant="pgiBtn"
                                                @click.prevent="redirectToWhatsapp(anggota.noHp)"
                                            >
                                                Hubungi WA
                                            </b-button>
                                            <b-button size="sm" variant="pgiBtn" @click="onCopyUrlWhatsApp(anggota.noHp)">
                                                <i class="fa fa-copy mr-1"></i>
                                                <span>Salin Link WA</span>
                                            </b-button>
                                        </template>
                                    </div>
                                </b-col>
                            </b-row>
                            <b-row class="mb-2">
                                <b-col cols="4" class="detail-data-label">Alamat</b-col>
                                <b-col>{{ anggota.alamat }}</b-col>
                            </b-row>
                        </div>

                        <!-- Foto KTP -->
                        <div class="foto-ktp w-full md:w-auto flex justify-center md:justify-start">
                            <img v-if="anggota.fotoKtp" :src="anggota.fotoKtp" width="250" class="rounded-lg shadow-md" alt="Foto Identitas"/>
                        </div>
                    </div>


            </div>
            <ModalPilihAnggota @anggota-selected="selectAnggota" />
            <b-tabs class="tab-wrapper" content-class="tab-content-wrapper" v-model="tabIndex" @input="isEmas">
                <b-tab title="Elektronik">
                     <b-form @submit.prevent="calculateElektronik">
                        <div class="form-content-wrapper">
                            <h6 class="form-title">DATA BARANG</h6>
                            <b-row>
                                <b-col  md="6" >
                                    <b-form-group label="Jenis Barang">
                                        <b-row>
                                            <b-col >
                                                <multiselect v-model="input.elek.jenis"  :options="optElekJenis" :internal-search="true"
                                                :allow-empty="false" deselect-label="" select-label="" label="name" track-by="id"
                                                placeholder="-- Please select an option --" />
                                            </b-col>
                                        </b-row>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="6">
                                    <b-form-group label="Merk Barang">
                                        <StateInputHandler
                                            :isLoading="stateMerkBarang.isLoading"
                                            :error="stateMerkBarang.error"
                                            errorMessage="Gagal memuat merk barang."
                                            @retry="getMerkBarang"
                                        >
                                            <multiselect
                                                v-model="input.elek.merk" 
                                                :disabled="!input.elek.jenis || optElekMerk.length == 0"
                                                :options="optElekMerk" 
                                                :internal-search="true"
                                                :allow-empty="false"
                                                deselect-label=""
                                                select-label=""
                                                label="name"
                                                track-by="id"
                                                placeholder="-- Please select an option --"
                                            />
                                            <EmptyStateInput v-if="input.elek.jenis && optElekMerk.length == 0" />
                                        </StateInputHandler>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row v-if="showSearchModel" class="mb-2">
                                <b-col md="6">
                                    <b-button @click="modalSearchModel" name="searchModel" variant="pgiBtn" class="mr-2">
                                        <i class="fa fa-search mr-2"></i>Cari Tipe dari Nomor Model
                                    </b-button>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="6">
                                    <b-form-group label="Tipe Barang" class="select-tipe-barang">
                                        <StateInputHandler
                                            :isLoading="stateTipeBarang.isLoading"
                                            :error="stateTipeBarang.error"
                                            errorMessage="Gagal memuat tipe barang."
                                            @retry="getTipeBarang"
                                        >
                                            <multiselect
                                                name="gadaiTipeBarangElektronik"
                                                v-model="input.elek.tipe" 
                                                :disabled="!input.elek.merk || optElekTipe.length == 0"
                                                :options="optElekTipe" 
                                                :internal-search="true"
                                                :allow-empty="true"
                                                deselect-label=""
                                                select-label=""
                                                label="name"
                                                track-by="name"
                                                placeholder="-- Please select an option --"
                                            />
                                            <small class="text-muted">{{ (tipeCreate == null) ?'dibuat pada -' :'dibuat pada '+ tipeCreate }} {{ $helper.isNullOrEmpty(input.elek.tipe) || $helper.isNullOrEmpty(input.elek.tipe.modelNumber) ? '' : ' , ' + input.elek.tipe.modelNumber }}</small>
                                            <EmptyStateInput v-if="input.elek.merk && optElekTipe.length == 0" />
                                        </StateInputHandler>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <div v-if="fotoTipeBarangElek.length > 0" class="mb-2">
                                <b-button class="btn" variant="pgiBtn" @click="()=> $bvModal.show('view-elektronik')">
                                   Lihat Foto Pendukung
                                </b-button>
                            </div>
                        
                            <b-row v-if="optElekTahun.length != 0">
                                <b-col md="6">
                                    <b-form-group label="Tahun / Generasi">
                                        
                                        <b-form-select v-model="input.elek.tahun" name="tahunElektronik" :options="optElekTahun">
                                            <template v-slot:first>
                                                <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
                                            </template>
                                        </b-form-select>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="6">
                                    <b-form-group label="Kondisi / Grade">
                                        <StateInputHandler
                                            :isLoading="stateGradeBarang.isLoading"
                                            :error="stateGradeBarang.error"
                                            errorMessage="Gagal memuat kondisi / grade barang."
                                            @retry="getGradeBarang"
                                        >
                                            <b-form-select v-model="input.elek.kondisi" name="gadaiGradeBarangClass" :options="optElekKondisi" :disabled="!input.elek.tipe || optElekKondisi.length == 0">
                                                <template v-slot:first>
                                                    <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
                                                </template>
                                            </b-form-select>

                                            <EmptyStateInput v-if="input.elek.tipe && optElekKondisi.length == 0" />
                                        </StateInputHandler>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row v-if="input.elek.merk && !showSearchModel">
                                <b-col md="6">
                                    <b-form-group label="No. Model">
                                        <b-form-select v-model="input.elek.modelNumber" name="noModel" :options="optModel">
                                            <template v-slot:first>
                                                <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
                                            </template>
                                        </b-form-select>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row v-if="input.elek.modelNumber == 'Lainnya'">
                                <b-col md="6">
                                    <b-form-group label="No. Model Lainnya">
                                        <b-form-input v-model="input.elek.modelNumberLainnya" maxLength="30" name="noModelLainnya"></b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row v-if="input.elek.jenis && input.elek.jenis.id == 1 || input.elek.jenis && input.elek.jenis.id == 3 || input.elek.jenis && input.elek.jenis.id == 9">
                                <b-col md="6" >
                                    <b-form-group label="No. IMEI / SN">
                                        <b-form-input v-model="input.elek.noImei" name="noImei"></b-form-input>
                                    </b-form-group>
                                </b-col>                
                            </b-row>
                            <b-row>
                                <b-col>
                                    <b-form-group label="Spesifikasi Barang (Jenis)">
										<b-row>
											<b-col md="6">
												<span class="text-muted">Penambahan</span>
                                                <StateCheckboxHandler
                                                    :isLoading="stateSpesifikasiJenisBarang.isLoading"
                                                    :error="stateSpesifikasiJenisBarang.error"
                                                    errorMessage="Gagal memuat spesifikasi jenis barang."
                                                    @retry="getSpesifikasiJenisBarang"
                                                >
                                                    <template v-if="optElekSpekJenis.penambahan.length > 0">
                                                        <b-form-checkbox-group class="mt-1" v-model="input.elek.spesifikasiJenis" name="gadaiPenambahanSpesifikasiJenisElek">
                                                            <b-form-checkbox class="d-block" v-for="item in optElekSpekJenis.penambahan" v-bind:key="item.id" :value="item.id">
                                                                {{ item.name }}
                                                            </b-form-checkbox>
                                                        </b-form-checkbox-group>
                                                    </template>
                                                    <template v-else>
                                                        <div class="text-muted mb-2">
                                                            Tidak ada spesifikasi penambahan dari jenis barang yang dipilih.
                                                        </div>
                                                    </template>
                                                </StateCheckboxHandler>
											</b-col>
											<b-col md="6">
												<span class="text-muted">Pengurangan</span>
                                                <StateCheckboxHandler
                                                    :isLoading="stateSpesifikasiJenisBarang.isLoading"
                                                    :error="stateSpesifikasiJenisBarang.error"
                                                    errorMessage="Gagal memuat spesifikasi jenis barang."
                                                    @retry="getSpesifikasiJenisBarang"
                                                >
                                                    <template v-if="optElekSpekJenis.pengurangan.length > 0">
                                                        <b-form-checkbox-group class="mt-1" v-model="input.elek.spesifikasiJenis" name="gadaiPenguranganSpesifikasiJenisElek">
                                                            <b-form-checkbox class="d-block" v-for="item in optElekSpekJenis.pengurangan" v-bind:key="item.id" :value="item.id">
                                                                {{ item.name }}
                                                                <b-button size="sm" :hidden="item.fotoSpesifikasi.length == 0" @click="openCarousel(item.id)" class="mr-3 table-button view" v-b-tooltip.hover title="Detail" name="jenisBarangViewBtn">
                                                                        <i class="fa fa-info"></i>
                                                                </b-button>
                                                                <ModalCarousel :foto="item.fotoSpesifikasi" :id="item.id" :hidden="item.fotoSpesifikasi.length == 0"/>
                                                            </b-form-checkbox>
                                                        </b-form-checkbox-group>
                                                    </template>
                                                    <template v-else>
                                                        <div class="text-muted mb-2">
                                                            Tidak ada spesifikasi pengurangan dari jenis barang yang dipilih.
                                                        </div>
                                                    </template>
                                                </StateCheckboxHandler>
											</b-col>
										</b-row>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <b-form-group label="Spesifikasi Barang (Merk)">
										<b-row>
											<b-col md="6">
												<span class="text-muted">Penambahan</span>
                                                <StateCheckboxHandler
                                                    :isLoading="stateSpesifikasiMerkBarang.isLoading"
                                                    :error="stateSpesifikasiMerkBarang.error"
                                                    errorMessage="Gagal memuat spesifikasi merk barang."
                                                    @retry="getSpesifikasiMerkBarang"
                                                >
                                                    <template v-if="optElekSpekMerk.penambahan.length > 0">
                                                        <b-form-checkbox-group class="mt-1" v-model="input.elek.spesifikasiMerk" name="gadaiPenambahanSpesifikasiMerkElek">
                                                            <b-form-checkbox class="d-block" v-for="item in optElekSpekMerk.penambahan" v-bind:key="item.id" :value="item.id">
                                                                {{ item.name }}
                                                            </b-form-checkbox>
                                                        </b-form-checkbox-group>
                                                    </template>
                                                    <template v-else>
                                                        <div class="text-muted mb-2">
                                                            Tidak ada spesifikasi penambahan dari merk barang yang dipilih.
                                                        </div>
                                                    </template>
                                                </StateCheckboxHandler>
											</b-col>
											<b-col md="6">
												<span class="text-muted">Pengurangan</span>
                                                <StateCheckboxHandler
                                                    :isLoading="stateSpesifikasiMerkBarang.isLoading"
                                                    :error="stateSpesifikasiMerkBarang.error"
                                                    errorMessage="Gagal memuat spesifikasi merk barang."
                                                    @retry="getSpesifikasiMerkBarang"
                                                >
                                                    <template v-if="optElekSpekMerk.pengurangan.length > 0">
                                                        <b-form-checkbox-group class="mt-1" v-model="input.elek.spesifikasiMerk" name="gadaiPenguranganSpesifikasiMerkElek">
                                                            <b-form-checkbox class="d-block" v-for="item in optElekSpekMerk.pengurangan" v-bind:key="item.id" :value="item.id">
                                                                {{ item.name }}
                                                            </b-form-checkbox>
                                                        </b-form-checkbox-group>
                                                    </template>
                                                    <template v-else>
                                                        <div class="text-muted mb-2">
                                                            Tidak ada spesifikasi pengurangan dari merk barang yang dipilih.
                                                        </div>
                                                    </template>
                                                </StateCheckboxHandler>
											</b-col>
										</b-row>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </div>     
                        <div class="form-wrapper-btn">
                            <b-button type="submit" name="simulasiHitungElektronikBtn" variant="pgiBtn" :disabled="isSubmitting">
                                <i class="fa fa-calculator mr-2"></i>
                                {{ isSubmitting ? "Menghitung..." : "Hitung" }}
                            </b-button>
                        </div>
                    </b-form>
                </b-tab>
                <b-tab title="Kendaraan">
                    <b-form @submit.prevent="calculateKendaraan">
                        <div class="form-content-wrapper">
                            <h6 class="form-title">DATA KENDARAAN</h6>
                            <b-row class="mb-1">
                                <b-col md="6">
                                    <template v-if="statePlatWilayah.isLoading">
                                        <b-spinner></b-spinner>
                                    </template>
                                    <template v-else-if="statePlatWilayah.isError">
                                        <b-alert 
                                            show 
                                            variant="danger"
                                        >
                                            <h5 class="alert-heading">Gagal Memuat Data!</h5>
                                            <p>
                                                Terjadi kesalahan saat mengambil data plat wilayah. Silakan coba lagi.
                                            </p>
                                            <hr>
                                            <b-button @click="getPlatWilayah" variant="danger">
                                                Coba Lagi
                                            </b-button>
                                        </b-alert>
                                    </template>
                                    <template v-else>
                                        <b-alert variant="info" show>
                                            <h5 class="alert-heading mb-1">Informasi</h5>
                                            <p class="smallText mb-0">
                                                <span class="text-muted">Saat ini plat kendaraan yang diterima adalah:</span>
                                                <span style="color: black; white-space: normal; word-break: break-word;">
                                                    {{ formatPlatWilayah(statePlatWilayah.data) }}
                                                </span>
                                            </p>
                                            <p class="smallText mb-0 mt-2">
                                                <span class="text-muted">Saat ini, KTP Nasabah yang diterima untuk gadai BPKB adalah dari provinsi:</span>
                                                <span style="color: black; white-space: normal; word-break: break-word;">
                                                    DKI Jakarta, Banten, Bali, Jawa Barat, Jawa Tengah, Jawa Timur, DI Yogyakarta, Sumatera Utara, Jambi, Lampung, Sumatera Selatan
                                                </span>
                                            </p>
                                        </b-alert>
                                    </template>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="6">
                                    <b-form-group label="Tipe Pinjaman">
                                        <div class="d-flex">
                                            <b-form-radio class="mr-3" v-model="tipePinjamanKendaraan" value="bpkb">BPKB Saja</b-form-radio>
                                            <!-- <b-form-radio v-model="tipePinjamanKendaraan" name="gadaiTipePinjamanElektronik" value="kendaraan">Kendaraan + BPKB</b-form-radio> -->
                                        </div>
                                    </b-form-group>
                                </b-col>   
                            </b-row>
                            <b-row>
                                <b-col md="6">
                                    <b-form-group label="Jenis Kendaraan">
                                        <multiselect
                                            v-model="input.kendaraan.jenis" 
                                            :options="optKendaraanJenis" 
                                            :internal-search="true"
                                            :allow-empty="false"
                                            deselect-label=""
                                            select-label=""
                                            label="name"
                                            track-by="id"
                                            placeholder="-- Please select an option --"
                                        />
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="6">
                                    <b-form-group label="Merk Kendaraan">
                                        <StateInputHandler
                                            :isLoading="stateMerkKendaraan.isLoading"
                                            :error="stateMerkKendaraan.error"
                                            errorMessage="Gagal memuat merk kendaraan."
                                            @retry="getMerkKendaraan"
                                        >
                                            <multiselect
                                                v-model="input.kendaraan.merk" 
                                                :disabled="!input.kendaraan.jenis || optKendaraanMerk.length == 0"
                                                :options="optKendaraanMerk" 
                                                :internal-search="true"
                                                :allow-empty="false"
                                                deselect-label=""
                                                select-label=""
                                                label="name"
                                                track-by="id"
                                                placeholder="-- Please select an option --"
                                            />
                                            <EmptyStateInput v-if="input.kendaraan.jenis && optKendaraanMerk.length == 0" />
                                        </StateInputHandler>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="6">
                                    <b-form-group label="Tipe Kendaraan">
                                        <StateInputHandler
                                            :isLoading="stateTipeKendaraan.isLoading"
                                            :error="stateTipeKendaraan.error"
                                            errorMessage="Gagal memuat tipe kendaraan."
                                            @retry="getTipeKendaraan"
                                        >
                                            <b-form-select v-model="input.kendaraan.tipe" name="gadaiTipeKendaraan" :disabled="!input.kendaraan.merk || optKendaraanTipe.length == 0">
                                                <template v-slot:first>
                                                    <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
                                                    <b-form-select-option v-for="(item, idx) in optKendaraanTipe" v-bind:value="{ id: item.id, name: item.name }" v-bind:key="idx">
                                                        {{ item.name }}
                                                    </b-form-select-option>
                                                </template>
                                            </b-form-select>
                                            <EmptyStateInput v-if="input.kendaraan.merk && optKendaraanTipe.length == 0" />
                                        </StateInputHandler>
                                    </b-form-group>
                                </b-col>
                              
                                <div v-if="fotoTipeBarangKend.length > 0">
                                    <b-button class="btn" variant="pgiBtn" @click="()=> $bvModal.show('view-kendaraan')">
                                    Lihat Foto Pendukung
                                    </b-button>
                                </div>
                            </b-row>
                            <b-row>
                                <b-col md="6">
                                    <b-form-group label="Tahun">
                                        <StateInputHandler
                                            :isLoading="stateGradeKendaraan.isLoading || stateTahunKendaraan.isLoading || isLoadingHasTahunKendaraan"
                                            :error="stateTahunKendaraan.error"
                                            errorMessage="Gagal memuat tahun kendaraan."
                                            @retry="getTahunKendaraan"
                                        >
                                            <b-form-select v-model="input.kendaraan.tahun" name="gadaiTahunKendaraan" :options="optKendaraanTahun" :disabled="!input.kendaraan.tipe || optKendaraanTahun.length == 0">
                                                <template v-slot:first>
                                                    <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
                                                </template>
                                            </b-form-select>
                                            <EmptyStateInput v-if="input.kendaraan.tipe && optKendaraanTahun.length == 0" />
                                        </StateInputHandler>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="6">
                                    <b-form-group label="Kondisi / Grade">
                                        <StateInputHandler
                                            :isLoading="stateGradeKendaraan.isLoading || stateTahunKendaraan.isLoading || isLoadingHasTahunKendaraan"
                                            :error="stateGradeKendaraan.error"
                                            errorMessage="Gagal memuat kondisi / grade kendaraan."
                                            @retry="getGradeKendaraan"
                                        >
                                            <b-form-select v-model="input.kendaraan.kondisi" name="gadaiKondisiKendaraan" :options="optKendaraanKondisi" :disabled="!input.kendaraan.tipe || optKendaraanKondisi.length == 0">
                                                <template v-slot:first>
                                                    <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
                                                </template>
                                            </b-form-select>
                                            <EmptyStateInput v-if="input.kendaraan.tipe && optKendaraanKondisi.length == 0" />
                                        </StateInputHandler>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="6">
                                    <label> Tanggal Berlaku Masa Pajak STNK </label>
                                    <b-form-group>
                                        <b-form-input type="date" v-model="tanggalPajak" :disabled="!input.kendaraan.kondisi" @blur="onBlurTanggalPajak" />
                                    </b-form-group>
                                </b-col>
                                        
                            </b-row>
                            <b-row>
                                <b-col>
                                    <b-form-group label="Spesifikasi Kendaraan (Jenis)">
										<b-row>
											<b-col md="6">
												<span class="text-muted">Penambahan</span>
                                                <StateCheckboxHandler
                                                    :isLoading="stateSpesifikasiJenisKendaraan.isLoading"
                                                    :error="stateSpesifikasiJenisKendaraan.error"
                                                    errorMessage="Gagal memuat spesifikasi jenis kendaraan."
                                                    @retry="getSpesifikasiJenisKendaraan"
                                                >
                                                    <template v-if="optKendaraanSpekJenis.penambahan.length > 0">
                                                        <b-form-checkbox-group class="mt-1" v-model="input.kendaraan.spesifikasiJenis" name="gadaiPenambahanSpekJenisBarangKend">
                                                            <b-form-checkbox class="d-block" v-for="item in optKendaraanSpekJenis.penambahan" v-bind:key="item.id" :value="item.id">
                                                                {{ item.name }}
                                                            </b-form-checkbox>
                                                        </b-form-checkbox-group>
                                                    </template>
                                                    <template v-else>
                                                        <div class="text-muted mb-2">
                                                            Tidak ada spesifikasi penambahan dari jenis kendaraan yang dipilih.
                                                        </div>
                                                    </template>
                                                </StateCheckboxHandler>
											</b-col>
											<b-col md="6">
												<span class="text-muted">Pengurangan</span>
                                                <StateCheckboxHandler
                                                    :isLoading="stateSpesifikasiJenisKendaraan.isLoading"
                                                    :error="stateSpesifikasiJenisKendaraan.error"
                                                    errorMessage="Gagal memuat spesifikasi jenis kendaraan."
                                                    @retry="getSpesifikasiJenisKendaraan"
                                                >
                                                    <template v-if="optKendaraanSpekJenis.pengurangan.length > 0">
                                                        <b-form-checkbox-group class="mt-1" v-model="input.kendaraan.spesifikasiJenis" name="gadaiPenguranganSpekJenisBarangKend">
                                                            <b-form-checkbox class="d-block" 
                                                                v-for="item in optKendaraanSpekJenis.pengurangan" 
                                                                :key="item.id" 
                                                                :value="item.id"
                                                                :disabled="item.name == 'Pajak Mati (a/n Sendiri)' || item.name == 'Pajak Mati (a/n Orang lain)' || item.name == 'Pajak Mati (a/n SENDIRI)' || item.name == 'Pajak Mati (a/n ORANG LAIN)' || item.name == 'Pajak Mati (a/n Sendiri Pick Up)' || item.name == 'Pajak Mati (a/n Orang Lain Pick Up)' || item.name == 'Pajak Mati (a/n SENDIRI PICK UP)' || item.name == 'Pajak Mati (a/n ORANG LAIN PICK UP)' ">
                                                                {{ item.name }}
                                                            </b-form-checkbox>
                                                        </b-form-checkbox-group>
                                                    </template>
                                                    <template v-else>
                                                        <div class="text-muted mb-2">
                                                            Tidak ada spesifikasi pengurangan dari jenis kendaraan yang dipilih.
                                                        </div>
                                                    </template>
                                                </StateCheckboxHandler>
											</b-col>
										</b-row>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <b-form-group label="Spesifikasi Kendaraan (Merk)">
										<b-row>
											<b-col md="6">
												<span class="text-muted">Penambahan</span>
                                                <StateCheckboxHandler
                                                    :isLoading="stateSpesifikasiMerkKendaraan.isLoading"
                                                    :error="stateSpesifikasiMerkKendaraan.error"
                                                    errorMessage="Gagal memuat spesifikasi merk kendaraan."
                                                    @retry="getSpesifikasiMerkKendaraan"
                                                >
                                                    <template v-if="optKendaraanSpekMerk.penambahan.length > 0">
                                                        <b-form-checkbox-group class="mt-1" v-model="input.kendaraan.spesifikasiMerk" name="gadaiPenambahanSpekMerkBarangKend">
                                                            <b-form-checkbox class="d-block" v-for="item in optKendaraanSpekMerk.penambahan" v-bind:key="item.id" :value="item.id">
                                                                {{ item.name }}
                                                            </b-form-checkbox>
                                                        </b-form-checkbox-group>
                                                    </template>
                                                    <template v-else>
                                                        <div class="text-muted mb-2">
                                                            Tidak ada spesifikasi penambahan dari merk kendaraan yang dipilih.
                                                        </div>
                                                    </template>
                                                </StateCheckboxHandler>
											</b-col>
											<b-col md="6">
												<span class="text-muted">Pengurangan</span>
                                                <StateCheckboxHandler
                                                    :isLoading="stateSpesifikasiMerkKendaraan.isLoading"
                                                    :error="stateSpesifikasiMerkKendaraan.error"
                                                    errorMessage="Gagal memuat spesifikasi merk kendaraan."
                                                    @retry="getSpesifikasiMerkKendaraan"
                                                >
                                                    <template v-if="optKendaraanSpekMerk.pengurangan.length > 0">
                                                        <b-form-checkbox-group v-model="input.kendaraan.spesifikasiMerk" name="gadaiPenguranganSpekMerkBarangKend">
                                                            <b-form-checkbox class="d-block" v-for="item in optKendaraanSpekMerk.pengurangan" v-bind:key="item.id" :value="item.id">
                                                                {{ item.name }}
                                                            </b-form-checkbox>
                                                        </b-form-checkbox-group>
                                                    </template>
                                                    <template v-else>
                                                        <div class="text-muted mb-2">
                                                            Tidak ada spesifikasi pengurangan dari merk kendaraan yang dipilih.
                                                        </div>
                                                    </template>
                                                </StateCheckboxHandler>
											</b-col>
										</b-row>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </div>
                        <div class="form-wrapper-btn">
                            <b-button type="submit" name="simulasiHitungKendaraanBtn" variant="pgiBtn">
                                <i class="fa fa-calculator mr-2"></i>
                                Hitung
                            </b-button>
                        </div>
                    </b-form>
                </b-tab>
                <b-tab title="Emas" v-if="gadaiEmas == 'true'">
                    <div class="card-wrapper emas-harga mb-4">
                        <div class="cash-balance">
                            <p class="mb-1">Harga Emas Sekarang</p>
                            <h4 class="nominal mb-0">
                                {{ 'Rp. '+$helper.addThousandSeparator(hargaEmasSekarang) }}
                            </h4>
                            <span class="small text-muted">Per 24 karat per gram</span>
                            <b-button class="d-block mt-2" variant="pgiBtn" @click="openModalJasa">
                                Lihat Jasa
                            </b-button>
                        </div>
                    </div>
               
                        <div class="form-content-wrapper">
                            <h6 class="form-title">DATA EMAS</h6>
                            <b-row>
                                <b-col cols="12" sm="6">
                                    <InputJenisEmas 
                                        :input="input.emas" 
                                        :optJenisEmas="optJenisEmas" 
                                        :pdfReadJenis="pdfReadJenis"
                                        :seJenis="seJenis"
                                        @openModalSE="openModalSE"
                                    />

                                    <!-- Logam Mulia (RETRO) 261 -->
                                    <div v-if="input.emas.jenisEmas != null && input.emas.jenisEmas.id == 261" >
                                        <InputMerkEmas 
                                            :input="input.emas" 
                                            :optMerkEmas="optMerkEmas"
                                            :karatOpt="karatOpt"
                                            :pdfReadMerk="pdfReadMerk"
                                            :seMerk="seMerk"
                                            :stateMerkEmas="stateMerkEmas"
                                            @getMerkEmas="getMerkEmas"
                                            @openModalSE="openModalSE"
                                            />

                                        <RadioAdaMerkPerusahaan :disabled="!IS_NON_ANTAM" :isAdaMerkPerusahaan="isAdaMerkPerusahaan" @isAdaMerkPerusahaan="(value) => { isAdaMerkPerusahaan = value }" />

                                        <InputTipeEmas 
                                            :input="input.emas" 
                                            :optTipeEmas="optTipeEmas" 
                                            :tipeCreate="tipeCreate" 
                                            :pdfReadTipe="pdfReadTipe" 
                                            :seTipe="seTipe"
                                            :stateTipeEmas="stateTipeEmas"
                                            @getTipeEmas="getTipeEmas"
                                            @openModalSE="openModalSE"
                                            />
                                        <!-- <InputCapEmas :input="input.emas" :optCapEmas="optCapEmas" :cap="cap"/> -->
                                        <div 
                                            v-if="input.emas.capEmas != null && fotoCapEmas.length > 0" >
                                            <b-button class="btn" variant="pgiBtn" @click="()=> $bvModal.show('view-cap-emas')">
                                               Lihat Foto Pendukung
                                            </b-button>
                                        </div>
                                        <InputKemasanEmas :input="input.emas" :optKemasanEmas="optKemasanEmas" />
                                        <InputBeratKering 
                                            :input="input.emas"
                                            :pdfReadBeratKering="pdfReadBeratKering"
                                            :seBeratKering="seBeratKering"
                                            :role="role"
                                            @roundPersen="roundPersen(6)"
                                            @openModalSE="openModalSE"
                                            />
                                    </div>

                                    <!-- Logam Mulia (SCAN) 251 -->
                                    <div v-if="input.emas.jenisEmas != null && input.emas.jenisEmas.id == 251" >
                                        <InputMerkEmas 
                                            :input="input.emas" 
                                            :optMerkEmas="optMerkEmas"
                                            :karatOpt="karatOpt"
                                            :pdfReadMerk="pdfReadMerk"
                                            :seMerk="seMerk"
                                            :stateMerkEmas="stateMerkEmas"
                                            @getMerkEmas="getMerkEmas"
                                            @openModalSE="openModalSE"
                                            />

                                        <InputTipeEmas 
                                            :input="input.emas" 
                                            :optTipeEmas="optTipeEmas" 
                                            :tipeCreate="tipeCreate" 
                                            :pdfReadTipe="pdfReadTipe" 
                                            :seTipe="seTipe"
                                            :stateTipeEmas="stateTipeEmas"
                                            @getTipeEmas="getTipeEmas"
                                            @openModalSE="openModalSE"
                                            />
                                        <!-- <InputCapEmas :input="input.emas" :optCapEmas="optCapEmas" :cap="cap"/> -->
                                        <div 
                                            v-if="input.emas.capEmas != null && fotoCapEmas.length > 0">
                                            <b-button class="btn" variant="pgiBtn" @click="()=> $bvModal.show('view-cap-emas')">
                                                Lihat Foto Pendukung
                                            </b-button>
                                        </div>
                                        <InputKemasanEmas :input="input.emas" :optKemasanEmas="optKemasanEmas" />
                                    </div>


                                    <!-- Perhiasan -->
                                    <div v-if="input.emas.jenisEmas != null && input.emas.jenisEmas.id == 257" >
                                        <!-- <InputMerkEmas 
                                            :input="input.emas" 
                                            :optMerkEmas="optMerkEmas"
                                            :karatOpt="karatOpt"
                                            :pdfReadMerk="pdfReadMerk"
                                            :seMerk="seMerk"
                                            @openModalSE="openModalSE"
                                            /> -->
                                            <InputCapGosokKwi 
                                                :data="this" 
                                                :input="input.emas" 
                                                :karatOpt="karatOpt" 
                                                :isSubmitting="isSubmitting"
                                                :gosok="gosok"
                                                :cap="cap"
                                                :kwitansi="kwitansi"
                                                :isAdaMerkPerusahaan="isAdaMerkPerusahaan"
                                                @gosok="( value ) => { gosok = value }"
                                                @cap="( value ) => { cap = value }"
                                                @kwitansi="( value ) => { kwitansi = value }"
                                                @isAdaMerkPerusahaan="( value ) => { isAdaMerkPerusahaan = value }"
                                                :optCapEmas="optCapEmas"
                                                :optKemasanEmas="optKemasanEmas"
                                                :role="role"
                                                :addBatu="addBatu"
                                                :isBusy="isBusy"
                                                :optPotonganTambahan="optPotonganTambahan"  
                                                :IS_REJECT_GADAI="IS_REJECT_GADAI"                              
                                                @kalkulasiKarat="kalkulasiKarat"
                                                @resetKarat="resetKarat"
                                                @openModalSE="openModalSE"
                                            />
                                                                                            
                                            <InputPointCapEmas :input="input.emas" :cap="cap" />
                                            <!-- <InputCapEmas :input="input.emas" :optCapEmas="optCapEmas" :cap="cap"/> -->
                                            <div 
                                                v-if="input.emas.capEmas != null && fotoCapEmas.length > 0" >
                                                <b-button class="btn" variant="pgiBtn" @click="()=> $bvModal.show('view-cap-emas')">
                                                    Lihat Foto Pendukung
                                                </b-button>
                                            </div>
                                            <InputKemasanEmas :input="input.emas" :optKemasanEmas="optKemasanEmas" />
                            
                                            <InputBeratKering 
                                                :input="input.emas"
                                                :pdfReadBeratKering="pdfReadBeratKering"
                                                :seBeratKering="seBeratKering"
                                                :role="role"
                                                @roundPersen="roundPersen(6)"
                                                @openModalSE="openModalSE"
                                                />

                                            <InputBatu 
                                                :input="input.emas"
                                                :isBusy="isBusy"
                                                :fieldsBatu="fieldsBatu"
                                                @addBatu="addBatu"
                                                @removeBatu="removeBatu"
                                                :batuOpt="batuOpt"
                                                />

                                            <InputBeratTambahan 
                                                :input="input.emas" 
                                                @roundPersenBeratTambahan="roundPersen(5)"
                                                @checkBeratTambahan="(value)=>{checkBeratTambahan = value}"
                                                />
                                            
                                            <InputPotonganTambahan 
                                                :input="input.emas" 
                                                :optPotonganTambahan="optPotonganTambahan"
                                                />
                                    </div>

                                  

                                    <b-form-group>
                                        <div>
                                            <b-row>
                                                <b-col cols="10" sm="4">
                                                    <label class="mr-2" for="">Bentuk Perhiasan</label>
                                                    <span v-if="optKelengkapanBarang.length != 0" :hidden="$companyId == 'PGI' ?false :true">
                                                        <b-badge :variant="pdfReadKelengkapan == false  ?'danger' :'primary'" :hidden="seKelengkapan == null ?true :false" size="sm" @click="openModalSE(seKelengkapan, 'kelengkapan' ,pdfReadKelengkapan)" v-b-tooltip.hover title="SE" name="jenisBarangViewBtn">
                                                            <i class="fa fa-info px-1"></i>
                                                        </b-badge>
                                                    </span>
                                                </b-col>
                                                <b-col cols=2 >
                                                
                                                </b-col>
                                            </b-row>
                                        </div>
                    
                                        <div v-if="optKelengkapanBarang.length == 0" class="text-muted">
                                            Tidak ada kelengkapan dari jenis barang yang dipilih.
                                        </div>

                                        <b-form-group v-else-if="input.emas.jenisEmas.id == 257" >
                                            <div v-for="item in optKelengkapanBarang" :key="item.id">
                                                <b-form-radio v-model="input.emas.kelengkapanBarang" class="my-2" :value="item.name"  name="gadaiKelengkapanBarang">
                                                    {{ item.name }}
                                                </b-form-radio>
                                            </div>
                                        </b-form-group>

                                        <b-form-checkbox-group v-else class="checkbox-group"  v-model="input.emas.kelengkapanBarang" name="gadaiKelengkapanBarang">
                                            <div class="d-block" v-for="item in optKelengkapanBarang" :key="item.id">
                                                <b-form-checkbox
                                                :value="item.name">
                                                    {{ item.name }}
                                                </b-form-checkbox>
                                            </div>
                                        </b-form-checkbox-group>

                            
                                    </b-form-group>

                                </b-col>
                            </b-row>		
                         
                        </div>
                        <div class="form-wrapper-btn footer-btn-simulasi-gadai-emas">
                            <b-button :hidden="IS_REJECT_GADAI" type="submit" name="simulasiHitungEmasBtn" variant="pgiBtn" @click="calculateEmas" :disabled="isSubmitting">
                                <i class="fa fa-calculator mr-2"></i>
                                {{ isSubmitting ? "Menghitung..." : "Hitung" }}
                            </b-button>
                            <b-button v-if="this.input.emas.jenisEmas == null || IS_REJECT_GADAI" type="submit" name="simulasiHitungElektronikBtn" variant="pgiBtn" @click="inputRejectGadaiEmas" :disabled="isSubmitting">
                                <i class="fa fa-edit mr-2"></i>
                                {{ isSubmitting ? "Input Reject Gadai Emas..." : "Input Reject Gadai Emas" }}
                            </b-button>
                        </div>
              
                </b-tab>
            </b-tabs>
            <b-modal id="modal-data-pinjaman" title="Taksiran Gadai" size="lg" 
                ok-only ok-title="Tutup" no-close-on-backdrop
            >
                <div class="detail-data-wrapper mb-4">
                    <h6 class="form-title mb-2">RINCIAN BARANG</h6>
                    <div v-if="isRecalculating" aria-busy="true">
                        <b-row v-for="n in 6" :key="n" class="mb-2">
                            <b-col cols="5"><div class="skeleton skeleton-value"></div></b-col>
                            <b-col><div class="skeleton skeleton-value"></div></b-col>
                        </b-row>
                    </div>
                    <template v-else>
                    <b-row class="mb-2">
                        <b-col cols="5" class="detail-data-label">Barang</b-col>
                        <b-col>
                            <div v-if="this.input.emas.jenisEmas && this.input.emas.jenisEmas.id == 257">
                                <strong>{{ namaBarang }}</strong>
                                <br>
                                <br>
                                <strong>{{ gosokCapKwitansi }}</strong>
                                <br>
                                <br>
                                <strong>{{ batuBarang }}</strong>
                            </div>
                            <div v-else>
                                <strong>{{ barangName }}</strong>
                            </div>
                            
                        </b-col>
                    </b-row>
                    <b-row v-if="!$helper.isNullOrEmpty(input.emas.capEmas)" class="mb-2">
                        <b-col cols="5" class="detail-data-label">Merk Cap Emas</b-col>
                        <b-col class="detail-data-label"><strong>{{ input.emas.capEmas.name }}</strong></b-col>
                    </b-row>
                    <b-row v-if="!$helper.isNullOrEmpty(input.emas.kemasanEmas)" class="mb-2">
                        <b-col cols="5" class="detail-data-label">Jenis Kemasan Emas</b-col>
                        <b-col class="detail-data-label"><strong>{{ input.emas.kemasanEmas.name }}</strong></b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="5" class="detail-data-label">Spek Barang</b-col>
                        <b-col>
                            <strong v-if="dataPinjam.spekBarang == 2">RESMI</strong>
                            <strong v-else-if="dataPinjam.spekBarang == 5">LN</strong>
                            <strong v-else>-</strong>
                        </b-col> 
                    </b-row>
                    <b-row class="mb-2">
                        <b-col v-if="dataPinjam.detailBatu != null && dataPinjam.detailBatu.length != 0" cols="5" class="detail-data-label">Potongan Berat</b-col>
                        <b-col>
                            <div v-for="(item, index) of dataPinjam.detailBatu" :key="index">
                            <strong> - {{ item }} </strong>
                            </div>
                        </b-col> 
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="5" class="detail-data-label">Harga Barang</b-col>
                        <b-col>
                            <strong>
                                Rp. {{ $helper.addThousandSeparator(dataPinjam.hargaBarang) }}
                            </strong>
                        </b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="5" class="detail-data-label">Kondisi - Grade {{ dataPinjam.perhitunganKondisi.name }}</b-col>
                        <b-col v-if="dataPinjam.perhitunganKondisi.nominal < 0" class="text-danger">
                            <strong>
                                Rp. {{ $helper.addThousandSeparator(dataPinjam.perhitunganKondisi.nominal) }}
                            </strong>
                        </b-col>
                        <b-col v-else>
                            <strong>
                                Rp. {{ $helper.addThousandSeparator(dataPinjam.perhitunganKondisi.nominal) }}
                            </strong>
                        </b-col>
                    </b-row>
  
					<b-row class="mb-2" v-if="dataPinjam.perhitunganAdjustmentSkemaDidepan != null">
						<b-col cols="5" class="detail-data-label">Adjustment Jasa Didepan</b-col>
						<b-col v-if="dataPinjam.perhitunganAdjustmentSkemaDidepan < 0" class="text-danger">
                            <strong>
                                Rp. {{ $helper.addThousandSeparator(dataPinjam.perhitunganAdjustmentSkemaDidepan) }}
                            </strong>
                        </b-col>
                        <b-col v-else>
                            <strong>
                                Rp. {{ $helper.addThousandSeparator(dataPinjam.perhitunganAdjustmentSkemaDidepan) }}
                            </strong>
                        </b-col>
					</b-row>
                    <b-row class="mb-2" v-if="dataPinjam.perhitunganAdjustmentSkemaAngsuran != null">
                        <b-col cols="5" class="detail-data-label">Adjustment Skema Angsuran</b-col>
                        <b-col :class="{ 'text-danger': dataPinjam.perhitunganAdjustmentSkemaAngsuran < 0 }">
                            <strong>
                                Rp. {{ $helper.addThousandSeparator(dataPinjam.perhitunganAdjustmentSkemaAngsuran) }}
                            </strong>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="5" class="mb-2 detail-data-label">Adjustment Status Anggota</b-col>
                        <b-col v-if="anggota.id == null || dataPinjam.perhitunganStatusAnggota == null">
                            <strong>
                                Rp. 0
                            </strong>
                        </b-col>
                        <b-col v-else class="text-success">
                            <strong>
                                Rp. {{ $helper.addThousandSeparator(dataPinjam.perhitunganStatusAnggota.nominal) }}
                            </strong>
                        </b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="5" class="detail-data-label">Bonus Gadai Pertama</b-col>
                        <b-col v-if="dataPinjam.perhitunganBonusGadaiPertama == null">
                            <strong>
                                Rp. 0
                            </strong>
                        </b-col>
                        <b-col v-else class="text-success">
                            <strong>
                                Rp. {{ $helper.addThousandSeparator(dataPinjam.perhitunganBonusGadaiPertama.nominal) }}
                            </strong>
                        </b-col>
                    </b-row>
                    </template>
                </div>
                <div class="detail-data-wrapper mb-4" v-if="!isRecalculating && dataPinjam.perhitunganSpek.length > 0">
                    <h6 class="form-title mb-2">RINCIAN SPESIFIKASI</h6>
                    <b-row v-for="item in dataPinjam.perhitunganSpek" v-bind:key="item.name" class="mb-2">
                        <b-col cols="5" class="detail-data-label">{{ item.name }}</b-col>
                        <b-col v-if="item.nominal < 0" class="text-danger">
                            <strong>
                                Rp. {{ $helper.addThousandSeparator(item.nominal) }}
                            </strong>
                        </b-col>
                        <b-col v-else>
                            <strong>
                                Rp. {{ $helper.addThousandSeparator(item.nominal) }} 
                            </strong>
                        </b-col>
                    </b-row>
                </div>
                <div class="detail-data-wrapper mb-4">
                    <h6 class="form-title mb-2">PERHITUNGAN PINJAMAN</h6>
                    <div v-if="isRecalculating" aria-busy="true">
                        <b-row v-for="n in 4" :key="n" class="mb-2">
                            <b-col cols="5"><div class="skeleton skeleton-value"></div></b-col>
                            <b-col><div class="skeleton skeleton-value"></div></b-col>
                        </b-row>
                    </div>
                    <template v-else>
                    <b-row class="mb-2" v-if="dataPinjam.hargaMaksimalKondisi != null">
                        <b-col cols="5" class="detail-data-label">Harga Maksimal Kondisi</b-col>
                        <b-col>
                            <strong>
                                Rp. {{ $helper.addThousandSeparator(dataPinjam.hargaMaksimalKondisi) }}
                            </strong>
                        </b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="5" class="detail-data-label">Pinjaman Maksimal</b-col>
                        <b-col>
                            <strong>
                                Rp. {{ $helper.addThousandSeparator(dataPinjam.maksimumPinjaman) }}
                            </strong>
                            <span class="smallText text-muted">
                                (Setelah Pembulatan)
                            </span>
                        </b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="5" class="detail-data-label">Pinjaman Minimal</b-col>
                        <b-col>
                            <strong>
                                Rp. {{ $helper.addThousandSeparator(dataPinjam.minimumPinjaman) }}
                            </strong>
                        </b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="5" class="detail-data-label">Harga Taksiran</b-col>
                        <b-col>
                            <strong>
                                Rp. {{ $helper.addThousandSeparator(dataPinjam.hargaTaksiran) }}
                            </strong>
                        </b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="5" class="detail-data-label">Nilai Pinjaman</b-col>
                        <b-col>
                            <b-input-group prepend="Rp.">
                                <b-form-input v-model="input.nilaiPinjaman" @focus="$event.target.select()" ref="inputNilaiPinjaman" name="nilaiPinjaman" required></b-form-input>
                            </b-input-group>
                        </b-col>
                    </b-row>
                    </template>
                    <b-row class="mb-2" v-if="installmentActive">
                        <b-col cols="5" class="detail-data-label">Metode Gadai</b-col>
                        <b-col>
                            <b-form-select v-model="input.metodeGadai" name="metodeGadai" :options="optionsMetodeGadai"
                                :disabled="isRecalculating" @change="recalculateSkema">
                                <template v-slot:first>
                                    <b-form-select-option :value="null" disabled>Silahkan pilih metode gadai</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                    </b-row>
                    <b-row class="mb-2" v-if="installmentActive && input.metodeGadai == 'angsuran'">
                        <b-col cols="5" class="detail-data-label">Tenor</b-col>
                        <b-col>
                            <b-form-select v-model="input.tenor" name="tenor" :options="optionsTenor">
                                <template v-slot:first>
                                    <b-form-select-option :value="null" disabled>Silahkan pilih tenor</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                    </b-row>
                    <b-row class="mb-2" v-if="installmentActive && input.metodeGadai == 'angsuran' && input.tenor != null && jadwalAngsuran.length > 0">
                        <b-col cols="5" class="detail-data-label">Angsuran per Bulan</b-col>
                        <b-col>
                            Rp. {{ $helper.addThousandSeparator(angsuranPerBulan) }}
                            <a class="ml-2" style="cursor:pointer; font-weight:bold; color:#1e73be" @click="showJadwalAngsuran = !showJadwalAngsuran">
                                {{ showJadwalAngsuran ? 'Sembunyikan Rincian' : 'Lihat Rincian' }}
                            </a>
                            <b-collapse v-model="showJadwalAngsuran" class="mt-2">
                                <div class="rincian-angsuran">
                                    <div v-for="row in jadwalAngsuran" :key="row.bulan" class="d-flex justify-content-between py-1 border-bottom">
                                        <span class="text-muted">Angsuran {{ row.bulan }}</span>
                                        <strong>Rp. {{ $helper.addThousandSeparator(row.cicilan) }}</strong>
                                    </div>
                                </div>
                            </b-collapse>
                        </b-col>
                    </b-row>
                    <b-row class="mb-2" v-if="installmentActive && input.metodeGadai == 'angsuran' && input.tenor != null && jadwalAngsuran.length > 0">
                        <b-col cols="5" class="detail-data-label">Total Angsuran</b-col>
                        <b-col><strong>Rp. {{ $helper.addThousandSeparator(totalAngsuran) }}</strong></b-col>
                    </b-row>
                </div>
                <b-alert variant="warning" class="mt-0" :show="isImeiBlacklisted">
                    <strong>Perhatian!</strong><br />
                    IMEI ini di blacklist, harap cek terlebih dahulu.
                </b-alert>
                <b-alert variant="warning" class="mt-0" :show="dataPinjam.maksimumPinjaman < dataPinjam.batasBawahPinjaman">
                    <strong>Perhatian!</strong><br />
                    Gadai ini dapat saja ditolak karena pinjaman maksimal anda tidak mencapai ketentuan batas bawah pinjaman {{ $footerName }}.
                </b-alert>

                <b-alert variant="danger" class="mt-0" :show="reasonCannotGadai">
                    <strong>Perhatian! Tidak dapat melanjutkan gadai!</strong><br />
                    {{ reasonCannotGadai }}
                </b-alert>

                <div class="footer-btn-taksiran-gadai">
                    <b-button v-if="!reasonCannotGadai" variant="pgiBtn" @click="tampilanCetak" :disabled="isSubmitting">
                        <i class="fa fa-print mr-2"></i>
                        {{ isSubmitting ? "Loading..." : "Cetak" }}
                    </b-button>
            
                    <b-button v-if="input.emas.jenisEmas != null " variant="pgiBtn" @click="inputRejectGadaiEmas(true)" :disabled="isSubmitting">
                        <i class="fa fa-print mr-2"></i>
                        {{ isSubmitting ? "Loading..." : "Input Reject Gadai Emas" }}
                    </b-button>

                    <b-button v-else variant="pgiBtn" @click="inputRejectGadai" :disabled="isSubmitting">
                        <i class="fa fa-edit mr-2"></i>
                        {{ isSubmitting ? "Loading..." : "Input Reject Gadai" }}
                    </b-button>

                    <b-button v-if="!reasonCannotGadai" variant="success" class="ml-2" @click="prosesGadai" :disabled="isSubmitting">
                        <i class="fa fa-arrow-right mr-2"></i>
                        {{ isSubmitting ? "Loading..." : "Lanjut Gadai" }}
                    </b-button>
                </div>
            </b-modal>

            <!-- MODAL SHOW SE -->
            <b-modal id="modal-SE" class="surat_edaran_modal" size="lg" title="Surat Edaran">
                <b-table bordered hover show-empty 
                    :fields="fields" 
                    :busy=false
                    :items="activeSE" 
                    :currentPage="currentPage" 
                    :perPage="perPage"
                    :borderless = true
                    :head-variant= null
                    responsive class="mb-3">
                    <template v-slot:header :hidden=true></template>
                    <template v-slot:cell(se)="row">
                        <iframe width="100%" height="700" allowfullscreen :src='$baseFilePath + row.item.filepath' frameborder="0"></iframe>
                    </template>
                </b-table>

                <div class="pagination-wrapper d-flex align-items-center justify-content-center">
                    <b-pagination class="mb-0"
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                        aria-controls="my-table"
                        @input="onPageChange"
                    ></b-pagination>
                </div>
                <template #modal-footer>
                    <div class="w-100">
                    </div>
                </template>
            </b-modal>

        </b-card>

        <b-modal title="Print Taksiran Gadai" ok-only no-close-on-esc no-close-on-backdrop size="xl" id="modal-print">
            <b-row class="mb-2">
                <b-col class="detail-data-label">Taksiran Gadai</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col><iframe width="100%" height="300" :src= urlTaksiran frameborder="0" allowfullscreen></iframe></b-col>
            </b-row>
            <b-row class="mb-2 align-items-center">
                <b-col class="detail-data-label d-flex align-items-center">
                Kode Cetak Simulasi :
                <span
                    class="ml-2 cursor-pointer text-primary font-weight-bold d-flex align-items-center"
                    @click="copyToClipboard(codeSimulasi)"
                    title="Klik untuk menyalin"
                >
                    {{ codeSimulasi }}  
                    <i class="fa fa-copy ml-2"></i>
                </span>
                </b-col>
            </b-row>
        </b-modal>

        <ModalCetakEmas
            :urlTaksiran="urlTaksiran"
            :codeSimulasi="codeSimulasi"
            @copy-code="copyToClipboard"
        />

        <b-modal title="Input Reject Gadai" ok-only no-close-on-esc no-close-on-backdrop size="md" id="modal-reject-gadai">
            <b-row>
                <b-col md="">
                    <b-form-group>
                        <label for="">Alasan Reject 
                            <b-badge :variant="pdfReadAlasanRejectGadai == false  ?'danger' :'primary'" :hidden="seAlasanRejectGadai == null ?true :false" @click="openModalSE(seAlasanRejectGadai, 'alasanRejectGadai' ,pdfReadAlasanRejectGadai)" v-b-tooltip.hover title="SE" name="jenisBarangViewBtn">
                                <i class="fa fa-info px-1"></i>
                            </b-badge>
                        </label>
                        <multiselect
                            name="alasanReject"
                            v-model="formReject.alasan" 
                            :disabled="optAlasan.length == 0"
                            :options="optAlasan" 
                            :internal-search="true"
                            :allow-empty="true"
                            deselect-label=""
                            select-label=""
                            label="name"
                            track-by="name"
                            placeholder="-- Please select an option --"
                        />
                    </b-form-group>
                </b-col>
            </b-row>

            <b-form-group label="Keterangan">
                <b-form-textarea id="textarea" v-model="formReject.keteranganAlasan" name="gadaiKondisi" rows=""
                    max-rows="" maxlength="200"></b-form-textarea>
            </b-form-group>

            <b-form-group label="Nama Nasabah">
                    <b-form-input v-model="formReject.nasabah" name="namaNasabah" maxlength="100" required></b-form-input>
            </b-form-group>

            <b-form-group>
                    <label>No. Hp</label>
                    <b-form-input v-model="formReject.noHp" name="no handphone" maxlength="40"></b-form-input>
            </b-form-group>

            <b-form-group>
                    <label> IMEI / SN / Nomor BPKB</label>
                    <b-form-input v-model="formReject.imeiSn" name="no handphone" maxlength="100" required></b-form-input>
            </b-form-group>

            <label for="">Pinjaman Kebutuhan Nasabah</label>
            <b-input-group prepend="Rp." >
                <b-form-input v-model="formReject.kebutuhanNasabah" @focus="$event.target.select()" ref="kebutuhanNasabah" name="kebutuhanNasabah" required></b-form-input>
            </b-input-group>

            <b-form-checkbox
                id="checkbox-1"
                v-model="formReject.isTipeTidakTerdaftar"
                name="checkbox-1"
                class="mt-4"
                >
                Apakah Tipe Barang Tidak Terdaftar ?
            </b-form-checkbox>

            <div v-if="formReject.isTipeTidakTerdaftar" class="mt-4">
                <label >Nama Tipe Tidak Terdaftar</label>
                <b-input-group>
                    <b-form-input v-model="formReject.namaTipeTidakTerdaftar" ref="namaTipeTidakTerdaftar" name="namaTipeTidakTerdaftar" maxlength="100" required></b-form-input>
                </b-input-group>
            </div>

            <div class="form-content-wrapper mt-4">
                <b-alert variant="warning" show v-if="formReject.alasan && formReject.alasan.requirePhoto == true" ><strong>Wajib mengisi minimal 1 foto pendukung</strong></b-alert>
                <b-alert variant="warning" show v-else >Foto Pendukung Opsional</b-alert>
                <div>
                    <b-button variant="pgiBtn" class="mb-2" @click="addFotoPendukungRejectGadai" name="fotoPendukungAddBtn"><i
                    class="fa fa-plus mr-2"></i>Foto Pendukung</b-button>
                    <div class="text-danger mt-2 mb-2" v-show="fotoPendukungError">* Foto Pendukung Maksimal 6 Foto
                    </div>
                    <FotoPendukung v-for="item in formReject.fotoPendukung" v-bind:key="item.index" :fotoPendukung="item"
                        :length="formReject.fotoPendukung.length" :minLength="minLengthFotoPendukung"
                        @remove="removeFotoPendukung" @showModalCam="openModalCam"
                        @showModalPreview="openModalPreview" :lat="lat" :long="long" isRemove />
                </div>
            </div>
            <template #modal-footer>
                <div class="">
                    <b-button variant="pgiBtn" class="ml-2" @click="submitRejectGadai" :disabled="isSubmitting">
                    <i class="fa fa-print mr-2"></i>
                    {{ isSubmitting ? "Loading..." : "Submit" }}
                    </b-button>
                </div>
            </template>
        </b-modal>

        <b-modal title="Input Reject Gadai Emas" ok-only no-close-on-esc no-close-on-backdrop size="md" id="modal-reject-gadai-emas">
            <b-row>
                <b-col md="">
                    <b-form-group>
                        <label for="">Alasan Reject 
                            <b-badge :variant="pdfReadAlasanRejectGadai == false  ?'danger' :'primary'" :hidden="seAlasanRejectGadai == null ?true :false" @click="openModalSE(seAlasanRejectGadai, 'alasanRejectGadai' ,pdfReadAlasanRejectGadai)" v-b-tooltip.hover title="SE" name="jenisBarangViewBtn">
                                <i class="fa fa-info px-1"></i>
                            </b-badge>
                        </label>
                        <multiselect
                            name="alasanReject"
                            v-model="formReject.alasan" 
                            :disabled="optAlasan.length == 0"
                            :options="optAlasan" 
                            :internal-search="true"
                            :allow-empty="true"
                            deselect-label=""
                            select-label=""
                            label="name"
                            track-by="name"
                            placeholder="-- Please select an option --"
                        />
                    </b-form-group>
                </b-col>
            </b-row>
            
            <b-form-group  v-if="input.emas.jenisEmas == null || IS_REJECT_GADAI" label="Jenis Perhiasan">
                <b-form-input v-model="formReject.jenisPerhiasan" name="jenisPerhiasam" maxlength="60" placeholder="Contoh: Emas Batangan, Berlian, Perak" required></b-form-input>
            </b-form-group>
                
            <b-form-group  v-if="input.emas.jenisEmas == null || IS_REJECT_GADAI" label="Karat">
                <b-form-input v-model="formReject.karat" name="karat" maxlength="60" required></b-form-input>
            </b-form-group>
                
            <b-form-group  v-if="input.emas.jenisEmas == null" label="Berat Kering" >
                <b-input-group append="Gram">
                    <b-form-input v-model="formReject.beratKering" name="beratKering" min="0" step="0.01" @blur="roundPersen(4)" @wheel="$event.target.blur()" type="number" required></b-form-input>
                </b-input-group>
            </b-form-group>  
        

            <b-form-group label="Keterangan">
                <b-form-textarea id="textarea" v-model="formReject.keteranganAlasan" name="gadaiKondisi" rows=""
                    max-rows="" maxlength="200"></b-form-textarea>
            </b-form-group>

            <b-form-group label="Nama Nasabah">
                    <b-form-input v-model="formReject.nasabah" name="namaNasabah" maxlength="100" required></b-form-input>
            </b-form-group>

            <b-form-group>
                    <label>No. Hp</label>
                    <b-form-input v-model="formReject.noHp" name="no handphone" maxlength="40"></b-form-input>
            </b-form-group>

            <label for="">Pinjaman Kebutuhan Nasabah</label>
            <b-input-group prepend="Rp." >
                <b-form-input v-model="formReject.kebutuhanNasabah" @focus="$event.target.select()" ref="kebutuhanNasabah" name="kebutuhanNasabah" required></b-form-input>
            </b-input-group>

            <b-form-checkbox
                id="checkbox-1"
                v-model="formReject.isTipeTidakTerdaftar"
                name="checkbox-1"
                class="mt-4"
                >
                Apakah Tipe Barang Tidak Terdaftar ?
            </b-form-checkbox>

            <div v-if="formReject.isTipeTidakTerdaftar" class="mt-4">
                <label >Nama Tipe Tidak Terdaftar</label>
                <b-input-group>
                    <b-form-input v-model="formReject.namaTipeTidakTerdaftar" ref="namaTipeTidakTerdaftar" name="namaTipeTidakTerdaftar" maxlength="100" required></b-form-input>
                </b-input-group>
            </div>

            
            <div class="form-content-wrapper mt-4">
                <b-alert variant="warning" show v-if="formReject.alasan && formReject.alasan.requirePhoto == true"><strong>Wajib mengisi minimal 1 foto pendukung</strong></b-alert>
                <b-alert variant="warning" show v-else >Foto Pendukung Opsional</b-alert>
                <div>
                    <b-button variant="pgiBtn" class="mb-2" @click="addFotoPendukungRejectGadai" name="fotoPendukungAddBtn"><i
                    class="fa fa-plus mr-2"></i>Foto Pendukung</b-button>
                    <div class="text-danger mt-2 mb-2" v-show="fotoPendukungError">* Foto Pendukung Maksimal 6 Foto
                    </div>
                    <FotoPendukung v-for="item in formReject.fotoPendukung" v-bind:key="item.index" :fotoPendukung="item"
                        :length="formReject.fotoPendukung.length" :minLength="minLengthFotoPendukung"
                        @remove="removeFotoPendukung" @showModalCam="openModalCam"
                        @showModalPreview="openModalPreview" :lat="lat" :long="long" isRemove />
                </div>
            </div>

            <template #modal-footer>
                <div class="">
                    <b-button variant="pgiBtn" class="ml-2" @click="submitRejectGadai" :disabled="isSubmitting">
                    <i class="fa fa-print mr-2"></i>
                    {{ isSubmitting ? "Loading..." : "Submit" }}
                    </b-button>
                </div>
            </template>
        </b-modal>

        <b-modal id="konfirm-submit-reject" title="Konfirmasi Submit reject gadai" size="lg" 
            no-close-on-backdrop no-close-on-esc :hide-header-close="isSubmitting"
            :ok-title="isSubmitting ? 'Menyimpan...' : 'Simpan'" 
            :ok-disabled="isSubmitting"
            @ok.prevent="doSubmitRejectGadai" auto-focus-button="ok"
            cancel-title="Tutup"
        >
            Dengan ini akan menginput reject gadai dengan data sebagai berikut:
            <div class="detail-data-wrapper mb-4 mt-4">
                <h6 class="form-title mb-2">DATA NASABAH</h6>
            
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">Nama</b-col>
                    <b-col>
                        {{ formReject.nasabah || '-'}}
                    </b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">No. Hp</b-col>
                    <b-col>
                        {{ (formReject.noHp != null || formReject.noHp != "") ?formReject.noHp :"" }}
                    </b-col>
                </b-row>
            </div>
            <div class="detail-data-wrapper mb-4">
                <h6 class="form-title mb-2">DATA REJECT</h6>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">Cabang</b-col>
                    <b-col>
                    {{ activeCabang }}
                    </b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">Alasan</b-col>
                    <b-col>
                        {{ (formReject.alasan != null) ?formReject.alasan.name :'' }}
                    </b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">Jenis Perhiasan</b-col>
                    <b-col>
                        {{ (formReject.jenisPerhiasan != null || formReject.jenisPerhiasan != "" ) ? formReject.jenisPerhiasan :'-' }}
                    </b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">Karat</b-col>
                    <b-col>
                        {{ (formReject.karat != null) ? formReject.karat + " K" :'-' }}
                    </b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">Berat Kering</b-col>
                    <b-col v-if="IS_REJECT_GADAI">
                        {{ (input.emas.beratKering != null) ?input.emas.beratKering + " Gram" :'-' }}
                    </b-col>
                    <b-col v-else>
                        {{ (formReject.beratKering != null) ?formReject.beratKering + " Gram" :'-' }}
                    </b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">Keterangan</b-col>
                    <b-col>
                        {{ formReject.keteranganAlasan || '-'}}
                    </b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">Barang</b-col>
                    <b-col>
                        <div v-if="input.emas.jenisEmas && input.emas.jenisEmas.id == 257">
                            {{ namaBarang }}
                            <br>
                            <br>
                            {{ gosokCapKwitansi }}
                            <br>
                            <br>
                            {{ batuBarang }}
                        </div>
                        <div v-else>
                            {{ barangName || '-'}}
                        </div>          
                    </b-col>
                </b-row>
                <b-row v-if="input.emas.jenisEmas != null && input.emas.jenisEmas.id == 257">
                    <b-col v-if="dataPinjam.detailBatu != null && dataPinjam.detailBatu.length != 0" cols="5" class="detail-data-label">Potongan Berat</b-col>
                    <b-col>
                        <div v-for="(item, index) of dataPinjam.detailBatu" :key="index">
                        - {{ item }}
                        </div>
                    </b-col> 
                </b-row>
                <b-row v-if="input.emas.jenisEmas == null" class="mb-2">
                    <b-col cols="5" class="detail-data-label">IMEI / SN / Nomor BPKB</b-col>
                    <b-col>
                        {{ formReject.imeiSn || '-'}}
                    </b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">Spek</b-col>
                    <b-col>
                        <div v-if="dataPinjam.spekBarang == 2">RESMI</div>
                        <div v-else-if="dataPinjam.spekBarang == 5">LN</div>
                        <div v-else>-</div>
                    </b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">No. Model</b-col>
                    <b-col v-if="input.elek.tipe && input.elek.tipe.noModel">
                        {{ (input.elek.tipe && input.elek.tipe.noModel) ?input.elek.tipe.noModel :'-' }}
                    </b-col>
                    <b-col >
                        {{ (input.elek.modelNumber) ?((input.elek.modelNumber == 'Lainnya') ?input.elek.modelNumberLainnya :input.elek.modelNumber) :'-' }}
                    </b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">Kondisi</b-col>
                    <b-col>
                        {{ (dataPinjam.perhitunganKondisi.length != 0 && dataPinjam.perhitunganKondisi.name != "") ? dataPinjam.perhitunganKondisi.name :"-" }}
                    </b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">Spesifikasi</b-col>
                    <b-col>
                        {{ formReject.spesifikasi || '-'}}
                    </b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">Pinjaman Maksimal</b-col>
                    <b-col>
                        Rp. {{ $helper.addThousandSeparator(dataPinjam.maksimumPinjaman) }}
                    </b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">Kebutuhan Nasabah</b-col>
                    <b-col>
                        Rp. {{ $helper.addThousandSeparator(formReject.kebutuhanNasabah) }}
                    </b-col>
                </b-row>
                <div v-if="formReject.isTipeTidakTerdaftar">
                    <b-row class="mb-2">
                        <b-col cols="5" class="detail-data-label">Tipe Tidak Terdaftar</b-col>
                        <b-col>
                            Ya
                        </b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="5" class="detail-data-label">Nama Tipe Tidak Terdaftar</b-col>
                        <b-col>
                            {{ formReject.namaTipeTidakTerdaftar || '-'}}
                        </b-col>
                    </b-row>
                </div>
            </div>
        </b-modal>

        <b-modal id="view-cap-emas" title="Foto Pendukung" size="lg" 
            no-close-on-backdrop no-close-on-esc 
        >
            <b-form-group>
                <span v-for="(item, index) in fotoCapEmas" :key="index">
                    <a v-bind:href="$companyId == 'PGI' ? $baseFilePath + item.name : item.name" target="_blank">
                        <img width="180px" :src="$companyId == 'PGI' ? $baseFilePath + item.name : item.name">
                    </a>
                    <p>{{formatTanggal(item.createdAt)}}</p>
                </span>
            </b-form-group>  
            <template v-slot:modal-footer="{ cancel }">
                <b-button variant="secondary" name="closePreviewBtn" @click="cancel()">
                    Close
                </b-button>
            </template>              
        </b-modal>

        <b-modal id="view-elektronik" title="Foto Pendukung" size="lg" 
            no-close-on-backdrop no-close-on-esc >
                <b-form-group>
                    <span class="mr-1" v-for="(item, index) in fotoTipeBarangElek" :key="index">
                        <a v-bind:href="item.name" target="_blank">
                            <img width="130px" height="130px" :src="item.name">
                        </a>
                    </span>
                </b-form-group>
            <template v-slot:modal-footer="{ cancel }">
                <b-button variant="secondary" name="closePreviewBtn" @click="cancel()">
                    Close
                </b-button>
            </template>              
        </b-modal>

        <b-modal id="view-kendaraan" title="Foto Pendukung" size="lg" 
            no-close-on-backdrop no-close-on-esc >
                <b-form-group>
                    <span class="mr-1" v-for="(item, index) in fotoTipeBarangKend" :key="index">
                        <a v-bind:href="$companyId == 'PGI' ? $baseFilePath + item.name : item.name" target="_blank">
                            <img width="130px" height="130px" :src="$companyId == 'PGI' ? $baseFilePath + item.name : item.name">
                        </a>
                    </span>
                </b-form-group>
            <template v-slot:modal-footer="{ cancel }">
                <b-button variant="secondary" name="closePreviewBtn" @click="cancel()">
                    Close
                </b-button>
            </template>              
        </b-modal>


            <b-modal id="modal-simulasi-bpkb" title="Tidak dapat melanjutkan gadai" hide-footer>
            <div class="text-center">
                <p>Anggota ini tidak dapat melanjutkan gadai karena masih memiliki gadai BPKB yang sedang berjalan.</p>
                <b-button variant="danger" @click="$bvModal.hide('modal-simulasi-bpkb')">Tutup</b-button>
            </div>
            </b-modal>

            <!-- <b-modal id="modal-lanjut-gadai" title="Lanjutkan Simulasi Gadai?" hide-footer>
            <div class="text-center">
                <p>Tidak ada gadai BPKB yang sedang berjalan. Anda dapat melanjutkan proses simulasi.</p>
                <b-button variant="success" @click="lanjutGadai">Lanjut Gadai</b-button>
                <b-button variant="secondary" class="ml-2" @click="$bvModal.hide('modal-lanjut-gadai')">Batal</b-button>
            </div>
            </b-modal> -->

        <ModalPreview modalId="modal-preview-gadai" :fotoPreview="activeFotoPreview" />
        <ModalWebCam idWebcam="webcam-input-elek" @photoTaken="setResult" />

        <ModalSearchModel :merkId="input.elek.merk && input.elek.merk.id || input.kendaraan.merk && input.kendaraan.merk.id || input.emas.merkEmas && input.emas.merkEmas.id" @model-selected="modelSelected"/>
        <ModalJasaEmas />
   </div>
</template>

<script>
import ModalPilihAnggota from './ModalPilihAnggota'
import ModalCarousel from '../../components/webcam/ModalCarousel.vue'
import ModalJasaEmas from '@/components/jasaEmas/JasaEmas'
import FotoPendukung from '../../components/webcam/FotoPendukung'
import ModalWebCam from '../../components/webcam/ModalWebCam'
import ModalPreview from '../../components/webcam/ModalPreview'
import ModalSearchModel from '@/components/gadai/MSearchModel.vue'
import InputJenisEmas from '../../atoms/emas/inputJenisEmas.vue'
import InputMerkEmas from '../../atoms/emas/inputMerkEmas.vue'
import InputTipeEmas from '../../atoms/emas/inputTipeEmas.vue'
import InputCapEmas from '../../atoms/emas/inputCapEmas.vue'
import InputKemasanEmas from '../../atoms/emas/inputKemasanEmas.vue'
import InputBeratKering from '../../atoms/emas/inputBeratKering.vue'
import InputCapGosokKwi from '../../atoms/emas/inputGosokCapKwi.vue'
import InputBatu from '../../atoms/emas/inputBatu.vue'
import InputBeratTambahan from '../../atoms/emas/inputBeratTambahan.vue'
import InputPotonganTambahan from '../../atoms/emas/inputPotonganTambahan.vue'
import InputPointCapEmas from '../../atoms/emas/inputPointCapEmas.vue'
import RadioAdaMerkPerusahaan from '../../atoms/emas/RadioAdaMerkPerusahaan.vue'
import StateInputHandler from '@/components/common/StateInputHandler'
import StateCheckboxHandler from '@/components/common/StateCheckboxHandler'
import EmptyStateInput from '@/components/common/EmptyStateInput'
import ModalCetakEmas from './ModalCetakEmas.vue'
import { enumJenisEmas } from "@/shared/utils";
import CONSTANTS from "@/constants";

const { JENIS } = CONSTANTS.GADAI;

export default {
    name: 'simulasi-gadai',
    components: {
        ModalPilihAnggota,
        ModalCarousel,
        ModalJasaEmas,
        ModalCetakEmas,
        ModalWebCam,
        FotoPendukung,
        ModalPreview,
        ModalSearchModel,
        InputJenisEmas,
        InputMerkEmas,
        InputTipeEmas,
        InputCapEmas,
        InputKemasanEmas,
        InputBeratKering,
        InputCapGosokKwi,
        InputBatu,
        InputBeratTambahan,
        InputPotonganTambahan,
        InputPointCapEmas,
        RadioAdaMerkPerusahaan,
        StateInputHandler,
        StateCheckboxHandler,
        EmptyStateInput,
    },
    data() {
        return {
            role: null,
            initStatus: 0,
            isSubmitting: false,
            cabangId: "",
            activeCabang: null,
            tabIndex: 0,
            activeTipe:null,
            activeKondisi: null,
            fromEmas : false,
            showSearchModel: false,

            namaBarang: "",
            gosokCapKwitansi: "",
            batuBarang: "",
           
            gadaiEmas : localStorage.getItem('gadaiEmasActive'),

            isImeiBlacklisted : false,
            isPajakValid : false,

            lat:0,
            long:0,
            anggota: {
                id: null,
                nama: "-",
                no: "-",
                noMember: null,
                jenisBarang: "-",
                jenisIdentitas: "-",
                noIdentitas: "-",
                noHp: "-",
                noRumah: "-",
                alamat: "-",
                detail: null,
                isComplete: false,
                shouldUpdate: false,
                fotoKtp :"",
            },

            cap:true,
            kwitansi:false,
            gosok:true,
            isAdaMerkPerusahaan: false,
            checkBeratTambahan: false,
            jenisPinjaman: 0,

            tanggalPajak: "",
            input: {
                elek: {
                    jenis: null,
                    jenisName: null,
                    merk: null,
                    merkName: null,
                    tipe: null,
                    tipeName: null,
                    tahun: null,
                    kondisi: null,
                    spesifikasiJenis: [],
                    spesifikasiMerk: [],
                    noImei: "",
                    modelNumber: null,
                    modelNumberLainnya: null,
                },
                kendaraan: {
                    bpkb: null,
                    jenis: null,
                    jenisName: null,
                    merk: null,
                    merkName: null,
                    tipe: null,
                    tipeName: null,
                    tahun: null,
                    kondisi: null,
                    spesifikasiJenis: [],
                    spesifikasiMerk: [],
                    tanggalPajak : "",
                    kendaraanKondisi :{},
                    spek:[],
                },
                emas: {
                    jenisEmas:null,
                    merkEmas:null,
                    tipeEmas:null,
                    karatEmas: null,
                    spesifikasiJenis: [],
                    kelengkapanBarang: [],
                    beratKering: null,
                    beratBasah: null,
                    jumlah : 1,
                    keterangan: "",
                    promo: [],
                    nilaiPinjaman: 0,
                    warnaBatu: null,
                    
                    batu:[],
                    beratTambahan: null,
                    potonganTambahan:[],

                    capEmas : null,
                    kemasanEmas : null,
                    pointCapEmas : null,
                },
                nilaiPinjaman: null,
                metodeGadai: null,
                tenor: null,
            },

            formReject:{
                alasan : null,
                jenisPerhiasan: "",
                karat : null,
                beratKering: null,
                keteranganAlasan : "",
                nasabah: null,
                noHp: null,
                imeiSn: null,
                kebutuhanNasabah: null,
                spesifikasi: null,
                isTipeTidakTerdaftar: false,
                namaTipeTidakTerdaftar: null,
                fotoPendukung: [
                    {
                        index: 0,
                        id: 0,
                        checkFotoBarangPendukung: false,
                        fotoBarangPendukungPlaceholder: 'Choose a file',
                        fotoBarangPendukung: null,
                        fotoBarangPendukungBase64: null,
                        activeFotoPendukungBase64: null,
                    }
                ],
            },

            tipeCreate : null,

            dataPinjam: {
                perhitunganKondisi: [],
                perhitunganSpek: []
            },

            optElekJenis: [],
            optElekMerk: [],
            optElekTipe: [],
            optElekTahun: [],
            optElekKondisi: [],
            optElekSpekJenis: {
                penambahan: [],
                pengurangan: []
            },
            optElekSpekMerk: {
                penambahan: [],
                pengurangan: []
            },
            tipePinjamanKendaraan: "bpkb",
            optKendaraanJenis: [],
            optKendaraanMerk: [],
            optKendaraanTipe: [],
            optKendaraanTahun: [],
            optKendaraanKondisi: [],
            optKendaraanSpekJenis: {
                penambahan: [],
                pengurangan: []
            },
            optKendaraanSpekMerk: {
                penambahan: [],
                pengurangan: []
            },
            optPotonganTambahan:[
                {id: 1 ,name: "Pengait ketempel magnet / Pengait gosokan hilang"},
            ],
            optJenisEmas:[],
            optMerkEmas:[],
            optTipeEmas:[],
            optCapEmas:[],
            optKemasanEmas:[],
            optionsMetodeGadai: [
                { value: 'non_angsuran', text: 'Non Angsuran' },
                { value: 'angsuran', text: 'Angsuran' },
            ],
            jadwalAngsuran: [],
            totalAngsuran: 0,
            showJadwalAngsuran: false,

            optEmasSpekJenis: [],
            hargaEmasSekarang: null,
            optAlasan : [],
            cabangOpt : [],

            warnaBatuOpt:[],
            karatOpt:[],

            barangName: null,
            urlTaksiran: null,
            codeSimulasi: null,
            fotoTipeBarangElek: [],
            fotoTipeBarangKend: [],
            fotoCapEmas: [],

            seAnggota : null,
            seJenis : null,
            seMerk : null,
            seTipe : null,
            seKondisi : null,
            seKelengkapan : null,
            seTahun : null,
            seBeratKering :null,
            seVolume :null,
            seWarnaBatu: null,
            seAlasanRejectGadai: null,

            activeSE : null,

            pdfReadAnggota: true,
            pdfReadJenis: true,
            pdfReadMerk: true,
            pdfReadTipe: true,
            pdfReadKelengkapan: true,
            pdfReadSpesifikasiJenis: true,
            pdfReadSpesifikasiMerk: true,
            pdfReadKondisi: true,
            pdfReadTahun: true,
            pdfReadBeratKering: true,
            pdfReadVolume: true,
            pdfReadWarnaBatu: true,
            pdfReadAlasanRejectGadai: true,

            slide: 0,
            sliding: null,

            fields: [
                { key: "se", label:"Surat Edaran"},
            ],

            i : 0,

            fieldsBatu: [
				{ key: "ukuran", label: "Ukuran"},
                { key: "jumlah", label: "Jumlah"},
				{ key: "action", label: "Aksi"}
			],
            batuOpt:[
                {name : "2/100", value : 0.02},
                {name : "3/100", value : 0.03},
                {name : "4/100", value : 0.04},
                {name : "5/100", value : 0.05},
                {name : "6/100", value : 0.06},
                {name : "7/100", value : 0.07},
                {name : "8/100", value : 0.08},
                {name : "9/100", value : 0.09},
                {name :"10/100", value : 0.1},
                {name :"15/100", value : 0.15},
                {name :"20/100", value : 0.2},
                {name :"25/100", value : 0.25},
                {name :"30/100", value : 0.3},
                {name :"35/100", value : 0.35},
                {name :"40/100", value : 0.4},
                {name :"45/100", value : 0.45},
                {name :"50/100", value : 0.5},
                {name :"55/100", value : 0.55},
                {name :"60/100", value : 0.6},
                {name :"65/100", value : 0.65},
                {name :"70/100", value : 0.7},
                {name :"75/100", value : 0.75},
                {name :"80/100", value : 0.8},
                {name :"85/100", value : 0.85},
                {name :"90/100", value : 0.9},
                {name :    "1" , value : 1},
                {name : "1,25" , value : 1.25},
                {name : "1,50" , value : 1.5},
                {name : "1,75" , value : 1.75},
                {name :    "2" , value : 2},
                {name :  "2,5" , value : 2.5},
                {name :    "3" , value : 3},
                {name :  "3,5" , value : 3.5},
                {name :    "4" , value : 4},
                {name :  "4,5" , value : 4.5},
                {name :    "5" , value : 5},
            ],

            optModel:[],

            isBusy: true,

            currentPage: 1,
            perPage: 1,
            rows: null,

            indexFotoPendukung: 1,
            fotoPendukungError: false,
            activeFotoPendukungIndex: null,
            activeFotoPreviewIndex: null,
            minLengthFotoPendukung: 1,
            activeFotoPreview: "",

            optKelengkapanBarang:[],
            statePlatWilayah: {
                data: [],
                isLoading: false,
                isError: false,
            },
            reasonCannotGadai: null,
            stateMerkBarang: {
                isLoading: false,
                error: null,
            },
            stateTipeBarang: {
                isLoading: false,
                error: null,
            },
            stateGradeBarang: {
                isLoading: false,
                error: null,
            },
            stateSpesifikasiJenisBarang: {
                isLoading: false,
                error: null,
            },
            stateSpesifikasiMerkBarang: {
                isLoading: false,
                error: null,
            },
            stateMerkKendaraan: {
                isLoading: false,
                error: null,
            },
            stateTipeKendaraan: {
                isLoading: false,
                error: null,
            },
            stateTahunKendaraan: {
                isLoading: false,
                error: null,
            },
            stateGradeKendaraan: {
                isLoading: false,
                error: null,
            },
            stateSpesifikasiJenisKendaraan: {
                isLoading: false,
                error: null,
            },
            stateSpesifikasiMerkKendaraan: {
                isLoading: false,
                error: null,
            },
            stateMerkEmas: {
                isLoading: false,
                error: null,
            },
            stateTipeEmas: {
                isLoading: false,
                error: null,
            },
            isLoadingHasTahunKendaraan: false,
            isRecalculating: false,
        }
    },
    methods: {
        recalculateSkema() {
            const calculate = { [JENIS.ELEKTRONIK]: this.calculateElektronik, [JENIS.KENDARAAN]: this.calculateKendaraan, [JENIS.EMAS]: this.calculateEmas }[this.jenisPinjaman]
            if (!calculate) return
            this.isRecalculating = true
            Promise.resolve(calculate()).then(success => {
                if (!success) return
                const skema = this.input.metodeGadai == 'angsuran' ? 'angsuran' : 'non angsuran'
                this.$helper.toastSucc(this, `Harga telah disesuaikan ke skema ${skema}.`, 'Penyesuaian Harga')
            }).finally(() => {
                this.isRecalculating = false
            })
        },

        getSimulasiAngsuran() {
            const endpoint = {
                [JENIS.ELEKTRONIK]: "gadai-crud/simulasi-angsuran/elektronik",
                [JENIS.KENDARAAN]: "gadai-crud/simulasi-angsuran/kendaraan",
                [JENIS.EMAS]: "gadai-emas/simulasi-angsuran",
            }[this.jenisPinjaman]
            if (!endpoint) return
            const params = {
                tenor: this.input.tenor,
                pinjamanPokokAwal: this.$helper.removeThousandSeparator(this.input.nilaiPinjaman),
            }
            if (this.jenisPinjaman == JENIS.KENDARAAN) params.bpkbOnly = this.tipePinjamanKendaraan != "kendaraan"
            this.$axios.get(endpoint, { params }).then(response => {
                const simulasi = response.data && response.data.simulasiAngsuran
                this.jadwalAngsuran = Array.isArray(simulasi) ? simulasi : []
                this.totalAngsuran = response.data && response.data.totalAngsuran || 0
            })
            .catch(error => {
                this.jadwalAngsuran = []
                this.showJadwalAngsuran = false
                this.$helper.parseError(this, error)
            })
        },

        //----------------- Fungsi Inisialisasi -----------------

        isEmas(tabIndex){
            if(tabIndex == 2){
                this.cekSimulasiGadaiEmas = true
                let getHargaEmasSekarang = this.$axios.get("harga-emas/current").then(response =>{
                    this.hargaEmasSekarang = response.data.id
                })
                
                let getJenisEmas = this.$axios.get(`barang-jenis/emas`).then(response => {
                this.optJenisEmas = response.data
                })
              
                let seBeratKering = this.$axios.get("surat-edaran/list/?menu=beratKering&jenis=beratKering").then(response => {
                    if(response.data.length != 0){
                    this.seBeratKering = response.data
                        for(var se of this.seBeratKering){
                            if(se.isViewSE == "false"){
                                this.pdfReadBeratKering = false
                            }
                        }
                    }
                 })

                let seVolume = this.$axios.get("surat-edaran/list/?menu=volume&jenis=volume").then(response => {
                    if(response.data.length != 0){
                    this.seVolume = response.data
                        for(var se of this.seVolume){
                            if(se.isViewSE == "false"){
                                this.pdfReadVolume = false
                            }
                        }
                    }
                })  

                let seAlasanRejectGadai = this.$axios.get("surat-edaran/list/?menu=alasanRejectGadai&jenis=alasanRejectGadai").then(response => {
                    if(response.data.length != 0){
                    this.seAlasanRejectGadai = response.data
                        for(var se of this.seAlasanRejectGadai){
                            if(se.isViewSE == "false"){
                                this.pdfReadAlasanRejectGadai = false
                            }
                        }
                    }
                })  

                let getPotonganTambahanEmas = this.$axios.get("spesifikasi-emas/selection").then(response => {
                    this.optPotonganTambahan = response.data
                })  

                Promise.all([getJenisEmas  , getHargaEmasSekarang, seBeratKering, seVolume, seAlasanRejectGadai,getPotonganTambahanEmas]).then(() => {
                })
                .catch(error => {
                    console.log(error)
                    this.$helper.parseError(this, error)
                })
            }else {
                this.cekSimulasiGadaiEmas = false
            }

            this.reset()
        },

        init() {
            this.initStatus = 0;
            this.role = localStorage.getItem('role');

            let getJenisElek = this.$axios.get("barang-jenis/elektronik").then(response => {
                this.optElekJenis = response.data;
            });
            let getJenisKendaraan = this.$axios.get("barang-jenis/kendaraan").then(response => {
                this.optKendaraanJenis = response.data
            })
            let getAlasan = this.$axios.get("gadai-reject-reason/selection").then(response => {
               
                for(var item of response.data){
                    item.requirePhoto = (item.requirePhoto.toString().toLowerCase() == "true")
                }
                this.optAlasan = response.data
            })

            let getCabang = localStorage.getItem("cabang")
            this.cabangOpt = JSON.parse(getCabang)

            Promise.all([getJenisElek, getJenisKendaraan, getAlasan]).then(() => {
                this.initStatus = 1;
                this.cabangId = this.$helper.getCabangId();
                this.toggleBusy()
            })
                .catch(error => {
                console.log(error);
                this.initStatus = -1;
            });
        },
        //----------------- Fungsi open modal carousel --------------
        openCarousel(id) {
            this.$bvModal.show("modal-carousel"+id);
        },
        calculateElektronik() {
            this.jenisPinjaman = JENIS.ELEKTRONIK
            this.fromEmas = false
            // ==== VALIDATION TESTS
            if (this.input.elek.kondisi == null) {
                this.$helper.toastErr(this, "Terdapat data tidak lengkap, mohon periksa kembali!");
                return;
            }
        
            if ( this.input.elek.jenis.id == 1 && this.$helper.isNullOrEmpty(this.input.elek.noImei)) {
                this.$helper.toastErr(this, "Terdapat data tidak lengkap, mohon periksa kembali!");
                return;
            }
            if ( this.input.elek.jenis.id == 3 && this.$helper.isNullOrEmpty(this.input.elek.noImei)) {
                this.$helper.toastErr(this, "Terdapat data tidak lengkap, mohon periksa kembali!");
                return;
            }
            if ( this.input.elek.jenis.id == 9 && this.$helper.isNullOrEmpty(this.input.elek.noImei)) {
                this.$helper.toastErr(this, "Terdapat data tidak lengkap, mohon periksa kembali!");
                return;
            }

            const isHandphone = this.input.elek.jenis && this.input.elek.jenis.name === 'Handphone';
            const imeiSn = this.input.elek.noImei
            if (!this.$helper.isValidImei(imeiSn) && isHandphone) {
                this.$helper.toastErr(this, "IMEI tidak valid, pastikan terdiri dari 15 karakter huruf atau angka.");
                return;
            }
            
            if (this.optElekTahun.length != 0 && this.input.elek.tahun == null) {
                this.$helper.toastErr(this, "Mohon memilih tahun barang!");
                return;
            }

            if (!this.showSearchModel && this.input.elek.modelNumber == null) {
                this.$helper.toastErr(this, "Mohon pilih No. Model!");
                return;
            }

            if (this.input.elek.modelNumber == 'Lainnya' && this.input.elek.modelNumberLainnya == null) {
                this.$helper.toastErr(this, "Mohon isi No. Model!");
                return;
            }
            // ==== VALIDATION PASSED
            let payload = new FormData()
            if(this.anggota.id != null){
                payload.append("nasabahId", this.anggota.id)
            }
            
            payload.append("jenisPinjamanId", 1) 
            payload.append("jenisId", this.input.elek.jenis.id)
            payload.append("merkId", this.input.elek.merk.id)
            payload.append("tipeId", this.input.elek.tipe.id)
			payload.append("kondisiId", this.input.elek.kondisi)
			payload.append("cabangId", this.cabangId)
            if (this.input.elek.modelNumber != null) {
                payload.append("modelNumber", (this.input.elek.modelNumber == 'Lainnya') ?this.input.elek.modelNumberLainnya :this.input.elek.modelNumber )
            }
            // Find whether to also append tahunId according to selection
            if (this.input.elek.tahun != null) {
                payload.append("tahunId", this.input.elek.tahun);
            }
            // Append all checked spesifikasi
            for (let spek of this.input.elek.spesifikasiJenis) {
                payload.append("spesifikasiId", spek);
            }
            for (let spek of this.input.elek.spesifikasiMerk) {
                payload.append("spesifikasiId", spek);
            }
            if (!this.$helper.isNullOrEmpty(this.input.elek.noImei)) {
                payload.append("imeiSn", this.input.elek.noImei)
            }
            payload.append("scheme", this.input.metodeGadai == 'angsuran' ? 1 : 0)
            // Do calculation
            this.isSubmitting = true;
            this.reasonCannotGadai = null;
            return this.$axios.post("gadai-crud/simulasi/elektronik", payload).then(response => {
                    this.isImeiBlacklisted = response.data.isImeiBlacklisted
                if (response.data.noFaktur == "REFRESH_KONDISI") {
                    this.$helper.toastErr(this, "Harga barang baru saja diperbarui HO. Silahkan isi ulang Kondisi / Grade Barang!");
                    this.input.elek.kondisi = null;
                    this.$axios.get(`barang-tipe-v2/kondisi/${this.input.elek.tipe.id}`).then(response => {
                        this.optElekKondisi = response.data.map(item => {
                            return { value: item.id, text: item.name };
                        });
                    });
                }
                else {
                    this.dataPinjam = response.data;
                    this.barangName = null;
                    this.barangName = this.input.elek.jenis.name + " - " + this.input.elek.merk.name + " - " + this.input.elek.tipe.name;
                    this.activeTipe = this.input.elek.tipe
                    this.input.nilaiPinjaman = this.$helper.addThousandSeparator(this.dataPinjam.maksimumPinjaman) 
                    this.reasonCannotGadai = response.data.reasonCannotGadai;
                    this.$bvModal.show("modal-data-pinjaman");
                    return true
                }
            })
                .catch(error => {
                this.$helper.parseError(this, error);
            })
                .finally(() => {
                this.isSubmitting = false;
            });
        },
        calculateKendaraan() {
            this.jenisPinjaman = JENIS.KENDARAAN
            this.fromEmas = false
            // ==== VALIDATION TESTS
            // Check if kondisi is not null
            if (this.input.kendaraan.kondisi == null) {
                this.$helper.toastErr(this, "Terdapat data tidak lengkap, mohon periksa kembali!");
                return;
            }
            // Check if tahun is available but not selected
            if (this.optKendaraanTahun.length != 0 && this.input.kendaraan.tahun == null) {
                this.$helper.toastErr(this, "Mohon memilih tahun barang!");
                return;
            }

            const resultValidatePajak = this.$helper.validateBatasMasaPajak(this.tanggalPajak);
            if (!resultValidatePajak.valid) {
                this.$helper.toastErr(this, resultValidatePajak.message);
                return;
            }
            
            // ==== VALIDATION PASSED
            let payload = new FormData()
            if(this.anggota.id != null){
                payload.append("nasabahId", this.anggota.id)
            }
            
            payload.append("jenisPinjamanId", 2) 
            payload.append("jenisId", this.input.kendaraan.jenis.id)
            payload.append("merkId", this.input.kendaraan.merk.id)
            payload.append("tipeId", this.input.kendaraan.tipe.id)
			payload.append("kondisiId", this.input.kendaraan.kondisi)
			payload.append("cabangId", this.cabangId)
			payload.append("stnkExpiredDate", this.tanggalPajak)
            
            if(this.tipePinjamanKendaraan == "kendaraan") payload.append("bpkbOnly", false)
            else payload.append("bpkbOnly", true)
            // Find whether to also append tahunId according to selection
            if (this.input.kendaraan.tahun != null) {
                payload.append("tahunId", this.input.kendaraan.tahun);
            }
            // Append all checked spesifikasi
            for (let spek of this.input.kendaraan.spesifikasiJenis) {
                payload.append("spesifikasiId", spek);
            }
            for (let spek of this.input.kendaraan.spesifikasiMerk) {
                payload.append("spesifikasiId", spek);
            }
            payload.append("scheme", this.input.metodeGadai == 'angsuran' ? 1 : 0)
            // Do calculation
            this.isSubmitting = true;
            this.reasonCannotGadai = null;
            return this.$axios.post("gadai-crud/simulasi/kendaraan", payload).then(response => {
                if (response.data.noFaktur == "REFRESH_KONDISI") {
                    this.$helper.toastErr(this, "Harga barang baru saja diperbarui HO. Silahkan isi ulang Kondisi / Grade Barang!");
                    this.input.kendaraan.kondisi = null;
                    this.optKendaraanKondisi = [];
                    this.$axios.get(`barang-tipe-v2/kondisi/${this.input.kendaraan.tipe.id}`).then(response => {
                        this.optKendaraanKondisi = response.data.map(item => {
                            return { value: item.id, text: item.name };
                        });
                    });
                }
                else {
                    this.dataPinjam = response.data;
                    this.barangName = null;
                    this.barangName = this.input.kendaraan.jenis.name + " - " + this.input.kendaraan.merk.name + " - " + this.input.kendaraan.tipe.name;
                    this.input.nilaiPinjaman = this.$helper.addThousandSeparator(this.dataPinjam.maksimumPinjaman) 
                    this.reasonCannotGadai = response.data.reasonCannotGadai;
                    this.$bvModal.show("modal-data-pinjaman");
                    this.activeTipe = this.input.kendaraan.tipe
                    return true
                }
            })
                .catch(error => {
                this.$helper.parseError(this, error);
            })
                .finally(() => {
                this.isSubmitting = false;
            });
        },
        openSearchAnggotaModal() {
            this.$bvModal.show("modal-pilih-anggota")
        },
        async selectAnggota(item) {
            const adaGadai = await this.cekGadaiBerjalan(item.id, this.tabIndex)
            if(adaGadai == true){
            this.$bvModal.hide("modal-pilih-anggota")
            this.$bvModal.show("modal-simulasi-bpkb")
            this.resetAnggota();
            }else{
            this.anggota.id = item.id
            this.anggota.nama = item.nama
            this.anggota.no = item.no
            this.anggota.noMember = item.noMember
            // this.anggota.jenisIdentitas = item.jenisIdentitas.name
            // this.anggota.noIdentitas = item.noIdentitas
            if (item.identitas && item.identitas.length > 0) {
                this.anggota.jenisIdentitas = item.identitas[0].jenisIdentitas
                this.anggota.noIdentitas = item.identitas[0].noIdentitas
                this.anggota.fotoKtp = item.identitas[0].fotoIdentitas
            }
            this.anggota.noHp = item.noHp
            this.anggota.noRumah = item.noRumah
            this.anggota.alamat = item.alamat
            this.anggota.identitas = item.identitas

            this.anggota.isComplete = item.isComplete
            this.anggota.shouldUpdate = item.shouldUpdateData
            this.anggota.shouldUpdatePhone = item.shouldUpdatePhone
            this.anggota.statusPembayaran = item.statusPembayaran
            this.anggota.detail = item.detail

            // calculate umur
            this.anggota.tanggalLahir = item.tanggalLahir

            this.valUmur = this.$helper.validasiUmurNasabah(this.anggota.tanggalLahir)
                
            if(item.shouldUpdatePhone == true){
                this.$bvModal.show("modal-update-telepon")
            }

            if (this.valUmur == false) {
                return this.$helper.toastErr(this, "Maaf umur nasabah belum 18 tahun, tidak bisa melakukan gadai.")
            }

            if (this.anggota.shouldUpdate == true) {
                this.$bvModal.hide("modal-pilih-anggota")
                this.$bvModal.show("modal-info-update")
            } else {
                this.$bvModal.hide("modal-pilih-anggota")
            }
                //----------------- GET REKENING NASABAH -----------------
                this.$axios.get("nasabah/list-rekening/" + this.anggota.id).then(response => {
                let rekening = []
                for(var data of response.data){
                    if(data.status == 1){
                        rekening.push(data)
                    }
                }
                this.anggota.rekening = rekening
            })
            }
               
        },
        calculateEmas(){
            this.jenisPinjaman = JENIS.EMAS
            this.fromEmas = true

            //Jika Logam Mulia
            if(this.input.emas.jenisEmas.id == 251){
                   if(this.input.emas.merkEmas == null
                    ) {
                        this.$helper.toastErr(this, "Mohon lengkapi data emas terlebih dahulu!")
                        return
                    }
                    if(this.input.emas.tipeEmas == null
                    ) {
                        this.$helper.toastErr(this, "Mohon lengkapi data emas terlebih dahulu!")
                        return
                    }
            }

            if(this.input.emas.jenisEmas.id == 257){
                    if ( this.gosok == true && this.cap == false) {
                        this.$helper.toastErr(this, "Tidak dapat menggadaikan emas ini! (Gosokan hilang tanpa cap)")
                        return
                    }
            
                    for(var data of this.input.emas.batu){
                        if (data.ukuran == null) {
                            this.$helper.toastErr(this, "Mohon lengkapi data batu terlebih dahulu!")
                            return
                        }
    
                        if (data.jumlah == 0) {
                            this.$helper.toastErr(this, "Jumlah Batu tidak boleh 0!")
                            return
                        }
                    }

                   if(this.input.emas.beratKering == null
                    ) {
                        this.$helper.toastErr(this, "Mohon input berat kering terlebih dahulu!")
                        return
                    }
                    if(this.cap == true && this.input.emas.karatEmas == null
                    ) {
                        this.$helper.toastErr(this, "Mohon lengkapi data emas terlebih dahulu!")
                        return
                    }

                    const isValid = this.validateSizes(this.input.emas.batu);
                    if (isValid) {
                        
                    } else {
                        this.$helper.toastErr(this, "Terdapat Ukuran Batu yang sama")
                        return
                    }

                    if (this.checkBeratTambahan == true) {
                        if (this.input.emas.beratTambahan == null || this.input.emas.beratTambahan == 0) {
                            this.$helper.toastErr(this, "Mohon isi Potongan Berat tambahan")
                            return
                        }
                    }

                    if (this.$helper.isNullOrEmpty(this.input.emas.kelengkapanBarang)){
                        this.$helper.toastErr(this, "Mohon pilih Kelengkapan")
                        return
                    }
            }

            if(this.input.emas.jenisEmas.id == 261){
                if(this.input.emas.merkEmas == null) {
                    this.$helper.toastErr(this, "Mohon lengkapi data emas terlebih dahulu!")
                    return
                }
                if(this.input.emas.tipeEmas == null) {
                    this.$helper.toastErr(this, "Mohon lengkapi data emas terlebih dahulu!")
                    return
                }
                if(this.input.emas.beratKering == null) {
                    this.$helper.toastErr(this, "Mohon lengkapi data emas terlebih dahulu!")
                    return
                }
            }

            let json = {
                cabangId : this.cabangId,
                keterangan : this.input.keterangan,
                core : {},
                nasabahId: this.anggota != null ? this.anggota.id : null,
                scheme: this.input.metodeGadai == 'angsuran' ? 1 : 0
            }

            if (this.input.emas.jenisEmas.id == 251) {
                json.core.jenisId = this.input.emas.jenisEmas.id
                json.core.merkId = this.input.emas.merkEmas.id
                json.core.tipeId = this.input.emas.tipeEmas.id
                json.core.jenisKemasanId = (this.input.emas.kemasanEmas != null) ?this.input.emas.kemasanEmas.id : null 
                json.core.capId = (this.input.emas.capEmas != null ) ?this.input.emas.capEmas.id : null 
                json.core.beratKering = null 
                json.core.dataPerhiasan = null 
            }
            
            if (this.input.emas.jenisEmas.id == 257) {
                json.core.jenisId = this.input.emas.jenisEmas.id
                json.core.merkId = this.input.emas.merkEmas.id
                json.core.tipeId = this.input.emas.karatEmas.id
                json.core.jenisKemasanId = (this.input.emas.kemasanEmas != null) ?this.input.emas.kemasanEmas.id : null 
                json.core.capId = (this.input.emas.capEmas != null ) ?this.input.emas.capEmas.id : null 
                json.core.beratKering = this.input.emas.beratKering 
                json.core.dataPerhiasan = {
                    gosokanHilang : this.gosok,
                    adaCap : this.cap,
                    adaKwitansi : this.kwitansi,
                    beratTambahan : (this.checkBeratTambahan == true) ? this.input.emas.beratTambahan : null,
                    kelengkapan : this.input.emas.kelengkapanBarang, 
                    listBatu :  (this.input.emas.batu.length != null ) ? Array.from(this.input.emas.batu, item => ({ jumlah: item.jumlah, ukuran: item.ukuran.value })) : null,
                    listSpekEmas: this.input.emas.potonganTambahan,
                    pointCapEmas : this.input.emas.pointCapEmas,
                    adaLogoPerusahaan: this.isAdaMerkPerusahaan,
                } 
                // if(this.capId){json.core.dataPerhiasan.pointCapEmas = this.input.emas.pointCapEmas}
            }
            
            if (this.input.emas.jenisEmas.id == 261) {
                json.core.jenisId = this.input.emas.jenisEmas.id
                json.core.merkId = this.input.emas.merkEmas.id
                json.core.tipeId = this.input.emas.tipeEmas.id
                json.core.jenisKemasanId = (this.input.emas.kemasanEmas != null) ?this.input.emas.kemasanEmas.id : null 
                json.core.capId = (this.input.emas.capEmas != null ) ?this.input.emas.capEmas.id : null 
                json.core.beratKering = this.input.emas.beratKering 
                json.core.dataPerhiasan = null
                json.core.dataPerhiasan = {
                    adaLogoPerusahaan: this.isAdaMerkPerusahaan,
                }
            }

            // Do calculation
            this.isSubmitting = true
            this.reasonCannotGadai = null;
            return this.$axios.post("gadai-emas/simulasi", json).then(response => {
                this.dataPinjam = response.data
                this.barangName = null
            
                // Arrange nama lengkap barang
                if(this.input.emas.jenisEmas.id == 251){
                    this.barangName = "Emas " + this.input.emas.jenisEmas.name + " - " + this.input.emas.merkEmas.name + " " + this.input.emas.tipeEmas.name
                }
                else if(this.input.emas.jenisEmas.id == 261){
                    const adaMerkPerusahaanText = this.isAdaMerkPerusahaan ? ' - Ada Merk Perusahaan' : ' - Tidak Ada Merk Perusahaan'
                    this.barangName = "Emas " + this.input.emas.jenisEmas.name + adaMerkPerusahaanText + " - " + this.input.emas.merkEmas.name + " " + this.input.emas.tipeEmas.name  + " - " + this.input.emas.beratKering + " Gram"
                }
                else if(this.input.emas.jenisEmas.id == 257){
                
                    this.barangName = `Emas ${this.input.emas.jenisEmas.name}, ${this.input.emas.karatEmas.name}. Angka Cap: ${this.input.emas.pointCapEmas}`;

                    this.barangName += (this.gosok == false) ? " Gosokan Tidak Hilang" : " Gosokan Hilang";
                    this.barangName += (this.cap == true) ? ", Ada Cap Karat" : ", Tidak Ada Cap Karat";
                    this.barangName += this.isAdaMerkPerusahaan ? ", Ada Merk Perusahaan" : ", Tidak Ada Merk Perusahaan"
                    this.barangName += `\nBerat Kering : ${this.input.emas.beratKering} gr. Potongan Berat : ${this.dataPinjam.beratBatu} gr. Berat Bersih : ${this.dataPinjam.beratEmas} gr.`;
                    
                    this.namaBarang = `Emas ${this.input.emas.jenisEmas.name}, ${this.input.emas.karatEmas.name}. Angka Cap: ${this.input.emas.pointCapEmas}`;
                    this.gosokCapKwitansi = (this.gosok == false) ? " Gosokan Tidak Hilang" : " Gosokan Hilang" 
                    this.gosokCapKwitansi += (this.cap == true) ? ", Ada Cap Karat" : ", Tidak Ada Cap Karat" 
                    this.gosokCapKwitansi += this.isAdaMerkPerusahaan ? ", Ada Merk Perusahaan" : ", Tidak Ada Merk Perusahaan"
                    this.batuBarang = `\nBerat Kering : ${this.input.emas.beratKering} gr. Potongan Berat : ${this.dataPinjam.beratBatu} gr. Berat Bersih : ${this.dataPinjam.beratEmas} gr.`;
                }
                else{
                    this.barangName = "Emas " + this.input.emas.jenisEmas.name + ", " + this.input.emas.merkEmas.name + " - " + this.input.emas.beratKering + " Gram"
                }
                
                this.reasonCannotGadai = response.data.reasonCannotGadai;
                this.input.nilaiPinjaman = this.$helper.addThousandSeparator(this.dataPinjam.maksimumPinjaman) 
                this.$bvModal.show("modal-data-pinjaman")
                this.activeTipe = this.input.emas.tipeEmas
                return true
            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
        },

        kalkulasiKarat(){
            // if (this.input.emas.merkEmas == null) {
            //     this.$helper.toastErr(this, "Mohon pilih merk emas!");
            //     return;
            // }
            this.input.emas.pointCapEmas = null
            this.input.emas.capEmas = null
            
            this.isSubmitting = true
            const params = {
                merkId: this.input.emas.merkEmas.id,
                adaCap: this.cap,
                adaKwitansi: this.kwitansi,
                gosokanHilang: this.gosok,
                adaLogoPerusahaan: this.isAdaMerkPerusahaan
            }
            this.$axios.get("gadai-emas/tipe-retro", { params }).then(response => {
                this.karatOpt= response.data 
                if (this.karatOpt.length === 1) {
                    this.input.emas.karatEmas = this.karatOpt[0]
                }
            })
            .catch(error => {
                this.$helper.parseError(this, error)
                this.isSubmitting = false
            })
            .finally(() => {
                this.isSubmitting = false
            })
        },

        resetKarat(){
            this.karatOpt = []
            this.input.emas.karatEmas = null
        },

        resetFormReject(){
            this.formReject = {
                alasan : null,
                jenisPerhiasan: "",
                karat : null,
                beratKering: null,
                keteranganAlasan : "",
                nasabah: null,
                noHp: null,
                imeiSn: null,
                kebutuhanNasabah: null,
                spesifikasi: null,
                isTipeTidakTerdaftar: false,
                namaTipeTidakTerdaftar: null,
                fotoPendukung: [
                    {
                        index: 0,
                        id: 0,
                        checkFotoBarangPendukung: false,
                        fotoBarangPendukungPlaceholder: 'Choose a file',
                        fotoBarangPendukung: null,
                        fotoBarangPendukungBase64: null,
                        activeFotoPendukungBase64: null,
                    }
                ],
            }
        },

        validateSizes(sizes) {
            const uniqueSizes = new Set();

            for (const item of sizes) {
                const size = item.ukuran.value;
      
                if (size != 99) {    
                    if (uniqueSizes.has(size)) {
                        return false;
                    }
                }
                uniqueSizes.add(size);
            }
            return true;
        },

        addBatu(){
            this.i ++
			this.input.emas.batu.push( { index : this.i, ukuran : null , jumlah : 0 })
        },
        
        removeBatu(index){
            this.input.emas.batu = this.input.emas.batu.filter(item => item.index != index)
        },

        inputRejectGadai(){
            this.resetFormReject()
            let idx = this.cabangOpt.findIndex(item => item.id == this.cabangId)
            this.activeCabang = this.cabangOpt[idx].name

            if (this.dataPinjam.perhitunganSpek.length != 0) {
                const names = this.dataPinjam.perhitunganSpek.map(item => item.name);
                const resultString = names.join(', ');
                this.formReject.spesifikasi = resultString
            }else{
                this.formReject.spesifikasi = "-"
            }

            if (this.anggota.id != null) {
                this.formReject.nasabah = this.anggota.nama
                this.formReject.noHp = this.anggota.noHp
            }

            if (!this.$helper.isNullOrEmpty(this.input.elek.noImei)) {
                this.formReject.imeiSn = this.input.elek.noImei
            }
            this.$bvModal.show("modal-reject-gadai")
        },

        inputRejectGadaiEmas(fromCalEmas = false){
            if (fromCalEmas == true) {
                this.fromEmas = true
            }else{
                this.fromEmas = false
            }
            this.resetFormReject()
            let idx = this.cabangOpt.findIndex(item => item.id == this.cabangId)
            this.activeCabang = this.cabangOpt[idx].name
           
            if (this.dataPinjam.perhitunganSpek.length != 0) {
                const names = this.dataPinjam.perhitunganSpek.map(item => item.name);
                const resultString = names.join(', ');
                this.formReject.spesifikasi = resultString
            }else{
                this.formReject.spesifikasi = "-"
            }

            if (this.anggota.id != null) {
                this.formReject.nasabah = this.anggota.nama
                this.formReject.noHp = this.anggota.noHp
            }
            if (this.IS_REJECT_GADAI) {

                if(this.input.emas.beratKering == null || this.input.emas.beratKering == 0) {
                        this.$helper.toastErr(this, "Mohon lengkapi data emas terlebih dahulu!")
                        return
                    }
                    
                if (this.checkBeratTambahan == true) {
                    if (this.input.emas.beratTambahan == null || this.input.emas.beratTambahan == 0) {
                        this.$helper.toastErr(this, "Mohon isi Potongan Berat tambahan")
                        return
                    }
                }


                this.barangName = null
                this.dataPinjam = {
                    perhitunganKondisi: [],
                    perhitunganSpek: []
                }
                this.namaBarang = ""
                this.gosokCapKwitansi = ""
                this.batuBarang = ""
            }
            this.$bvModal.show("modal-reject-gadai-emas")
        },

        addFotoPendukungRejectGadai() {
            if (this.formReject.fotoPendukung.length < 6) {
                this.formReject.fotoPendukung.unshift({
                    id: 0,
                    index: this.indexFotoPendukung,
                    checkFotoBarangPendukung: false,
                    fotoBarangPendukungPlaceholder: 'Choose a file',
                    fotoBarangPendukung: null,
                    fotoBarangPendukungBase64: null,
                    activeFotoPendukungBase64: null
                })
                this.indexFotoPendukung++;
            } else {
                this.fotoPendukungError = true;
            }
        },

        removeFotoPendukung(index) {
            this.formReject.fotoPendukung = this.formReject.fotoPendukung.filter(item => item.index != index)
            this.fotoPendukungError = false;
        },

        openModalCam(index) {
            this.activeFotoPendukungIndex = index
            this.$bvModal.show("webcam-input-elek")
        },

        async setResult(result) {
            let formattedDate = this.$helper.formatTanggalDMY()
            let waktu = this.$helper.waktu24()
        
           var newResult = await this.$helper.resizeImage(result)

           let img = new Image()
           img.src = newResult
           img.onload = () => {
               let canvas = document.createElement('canvas')
               let ctx = canvas.getContext('2d')
               canvas.setAttribute("width", img.width);
               canvas.setAttribute("height", img.height);
               ctx.drawImage(img, 0, 0,)
               ctx.font = "14pt Arial";
               ctx.fillStyle = "#ffffff"; 
               ctx.fillText(formattedDate + ' ' + waktu, 10, img.height - 40 ,);
               ctx.strokeText(formattedDate + ' ' + waktu, 10, img.height - 40 ,);
               ctx.fillText(this.lat + ' ' +this.long, 10, img.height - 10 ,);
               ctx.strokeText(this.lat + ' ' +this.long, 10, img.height - 10 ,);
               let newBase64Str = canvas.toDataURL('image/jpeg', 0.9)

               let idx = this.formReject.fotoPendukung.findIndex(item => item.index == this.activeFotoPendukungIndex);
                this.formReject.fotoPendukung[idx].fotoBarangPendukungBase64 = newBase64Str
                this.formReject.fotoPendukung[idx].activeFotoPendukungBase64 = newBase64Str
                this.formReject.fotoPendukung[idx].fotoBarangPendukungPlaceholder = "Foto dari Kamera"
                this.formReject.fotoPendukung[idx].checkFotoBarangPendukung = true
           }
        },

        openModalPreview(index) {
            this.activeFotoPreviewIndex = index
            let idx = this.formReject.fotoPendukung.findIndex(item => item.index == this.activeFotoPreviewIndex);
            this.activeFotoPreview = this.formReject.fotoPendukung[idx].fotoBarangPendukungBase64
            this.$bvModal.show("modal-preview-gadai")
        },

        submitRejectGadai(){
            if (this.formReject.alasan == null) {
                return this.$helper.toastErr(this, "Mohon pilih alasan terlebih dahulu!")
            }
            if (this.formReject.keteranganAlasan == "" || this.formReject.keteranganAlasan == null) {
                return this.$helper.toastErr(this, "Mohon isi keterangan terlebih dahulu!")
            }
            
            if (this.input.emas.jenisEmas == null && this.input.elek.jenis == null && this.input.kendaraan.jenis == null || this.cap == false && this.gosok == true) {
                if (this.formReject.jenisPerhiasan == "" || this.formReject.jenisPerhiasan == null) {
                return this.$helper.toastErr(this, "Mohon isi Jenis Perhiasan terlebih dahulu!") 
                }

                if (this.formReject.karat == "" || this.formReject.karat == null) {
                return this.$helper.toastErr(this, "Mohon isi Karat terlebih dahulu!")
                }

                this.barangName = null
                this.dataPinjam = {
                    perhitunganKondisi: [],
                    perhitunganSpek: []
                }
                this.namaBarang = "-"
                this.gosokCapKwitansi = ""
                this.batuBarang = ""

            }
            if (this.input.emas.jenisEmas == null && this.input.elek.jenis == null && this.input.kendaraan.jenis == null){
                if (this.formReject.beratKering == "" || this.formReject.beratKering == null) {
                return this.$helper.toastErr(this, "Mohon isi Berat Kering terlebih dahulu!")
                }
            }
            if (this.formReject.nasabah == "" || this.formReject.nasabah == null) {
                return this.$helper.toastErr(this, "Mohon isi Nama Nasabah terlebih dahulu!")
            }
            if (this.formReject.noHp == "" || this.formReject.noHp == null) {
                this.formReject.noHp = 0
            }

            if (this.input.elek.jenis && this.input.elek.jenis.id == 1 && this.$helper.isNullOrEmpty(this.formReject.imeiSn)) {
                return this.$helper.toastErr(this, "Mohon isi No. IMEI terlebih dahulu!")
            } else{
                if (this.formReject.imeiSn == "" || this.formReject.imeiSn == null) {
                    this.formReject.imeiSn = "0"
                }
            }

            if ( this.input.elek.jenis && this.input.elek.jenis.id == 3 && this.$helper.isNullOrEmpty(this.formReject.imeiSn)) {
                return this.$helper.toastErr(this, "Mohon isi No. IMEI terlebih dahulu!")
            } else{
                if (this.formReject.imeiSn == "" || this.formReject.imeiSn == null) {
                    this.formReject.imeiSn = "0"
                }
            }

            if ( this.input.elek.jenis && this.input.elek.jenis.id == 9 && this.$helper.isNullOrEmpty(this.formReject.imeiSn)) {
                return this.$helper.toastErr(this, "Mohon isi No. IMEI terlebih dahulu!")
            } else{
                if (this.formReject.imeiSn == "" || this.formReject.imeiSn == null) {
                    this.formReject.imeiSn = "0"
                }
            }

            if (this.formReject.kebutuhanNasabah == "" || this.formReject.kebutuhanNasabah == null) {
                return this.$helper.toastErr(this, "Mohon isi nominal kebutuhan nasabah terlebih dahulu!")
            }

            if (this.formReject.isTipeTidakTerdaftar == true && this.$helper.isNullOrEmpty(this.formReject.namaTipeTidakTerdaftar)) {
                return this.$helper.toastErr(this, "Mohon isi nama tipe tidak terdaftar terlebih dahulu!")
            }

            if (this.formReject.alasan.requirePhoto == true) {
                // Check if there is at least one picture attached
                if (this.formReject.fotoPendukung.length == 1 && this.$helper.isNullOrEmpty(this.formReject.fotoPendukung[0].activeFotoPendukungBase64)) {
                    this.$helper.toastErr(this, "Mohon upload minimal 1 gambar!")
                    return
                }    
                // Check if all photo row has been filled
                for (var i = 0; i < this.formReject.fotoPendukung.length; i++) {
                    let item = this.formReject.fotoPendukung[i]
                    if (this.$helper.isNullOrEmpty(item.activeFotoPendukungBase64)) {
                        this.$helper.toastErr(this, "Terdapat upload gambar yang kosong, periksa kembali!")
                        return
                    }
                }
            }


            this.$bvModal.show("konfirm-submit-reject")

        },

        doSubmitRejectGadai(){
            let json = {}
            let payload = new FormData()
            
            payload.append("cabangId", this.cabangId)
            payload.append("reasonId", this.formReject.alasan.id)
            payload.append("namaNasabah", this.formReject.nasabah)
            payload.append("noHpNasabah", (this.formReject.noHp != null || this.formReject.noHp != "") ? this.formReject.noHp : "-")
            payload.append("keterangan", this.formReject.keteranganAlasan)
          
            if (this.input.elek.jenis == null && this.input.kendaraan.jenis == null && this.input.emas.jenisEmas == null) {
                payload.append("jenisPerhiasan", this.formReject.jenisPerhiasan)
                payload.append("karat", this.formReject.karat)
                payload.append("beratKering", this.formReject.beratKering)
                payload.append("berat", this.formReject.beratKering)
            } else {
    
                payload.append("isTipeTidakTerdaftar", this.formReject.isTipeTidakTerdaftar)
            
                if (this.formReject.isTipeTidakTerdaftar == true) {
                    payload.append("namaTipeTidakTerdaftar", this.formReject.namaTipeTidakTerdaftar)
                }
              
                if (this.fromEmas == true) {
                    let jsonFoto = []
                    this.formReject.fotoPendukung.forEach(function (entry) {
                        if (entry.activeFotoPendukungBase64 != null) {
                            jsonFoto.push(entry.activeFotoPendukungBase64)
                        }
                    })
                    if (jsonFoto.length != 0) {
                        payload.append("foto", JSON.stringify(jsonFoto))
                    }
                    json = {
                        core : { 
                                cabangId: this.cabangId,
                                reasonId: this.formReject.alasan.id,
                                namaNasabah: this.formReject.nasabah,
                                noHpNasabah: (this.formReject.noHp != null || this.formReject.noHp != "") ? this.formReject.noHp : "-",
                                keterangan: this.formReject.keteranganAlasan,
                                pinjamanMaksimal:  (this.dataPinjam.maksimumPinjaman != undefined) ?this.dataPinjam.maksimumPinjaman :0,
                                pinjamanKebutuhanNasabah: this.$helper.removeThousandSeparator(this.formReject.kebutuhanNasabah),
                                isTipeTidakTerdaftar: this.formReject.isTipeTidakTerdaftar,
                                namaTipeTidakTerdaftar: this.formReject.namaTipeTidakTerdaftar, // string apabila tipe tidak terdaftar
                                foto: jsonFoto
                                },
                                
                        dataEmas: {}
                    }

                    if (this.input.emas.jenisEmas.id == 251) {
                        json.dataEmas.jenisId = this.input.emas.jenisEmas.id
                        json.dataEmas.merkId = this.input.emas.merkEmas.id
                        json.dataEmas.tipeId = this.input.emas.tipeEmas.id
                        json.dataEmas.jenisKemasanId = (this.input.emas.kemasanEmas != null) ?this.input.emas.kemasanEmas.id : null 
                        json.dataEmas.capId = (this.input.emas.capEmas != null && this.cap) ?this.input.emas.capEmas.id : null 
                        json.dataEmas.beratKering = null 
                        json.dataEmas.dataPerhiasan = null 
                    }
                    
                    if (this.input.emas.jenisEmas.id == 257) {
                        json.dataEmas.jenisId = this.input.emas.jenisEmas.id
                        json.dataEmas.merkId = this.input.emas.merkEmas.id
                        json.dataEmas.tipeId = this.input.emas.karatEmas.id
                        json.dataEmas.jenisKemasanId = (this.input.emas.kemasanEmas != null) ?this.input.emas.kemasanEmas.id : null 
                        json.dataEmas.capId = (this.input.emas.capEmas != null && this.cap) ?this.input.emas.capEmas.id : null 
                        json.dataEmas.beratKering = this.input.emas.beratKering 
                        json.dataEmas.dataPerhiasan = {
                            gosokanHilang : this.gosok,
                            adaCap : this.cap,
                            adaKwitansi : this.kwitansi,
                            beratTambahan : (this.checkBeratTambahan == true) ? this.input.emas.beratTambahan : null,
                            kelengkapan : this.input.emas.kelengkapanBarang, 
                            pointCapEmas : this.input.emas.pointCapEmas,
                            listBatu :  (this.input.emas.batu.length != null ) ? Array.from(this.input.emas.batu, item => ({ jumlah: item.jumlah, ukuran: item.ukuran.value })) : null,
                            listSpekEmas: this.input.emas.potonganTambahan,
                            adaLogoPerusahaan: this.isAdaMerkPerusahaan,
                        } 
                    }
                    
                    if (this.input.emas.jenisEmas.id == 261) {
                        json.dataEmas.jenisId = this.input.emas.jenisEmas.id
                        json.dataEmas.merkId = this.input.emas.merkEmas.id
                        json.dataEmas.tipeId = this.input.emas.tipeEmas.id
                        json.dataEmas.jenisKemasanId = (this.input.emas.kemasanEmas != null) ?this.input.emas.kemasanEmas.id : null 
                        json.dataEmas.capId = (this.input.emas.capEmas != null && this.cap) ?this.input.emas.capEmas.id : null 
                        json.dataEmas.beratKering = this.input.emas.beratKering 
                        json.dataEmas.dataPerhiasan = {
                            adaLogoPerusahaan: this.isAdaMerkPerusahaan,
                        }
                    }
                    
                }
              
                else if (this.IS_REJECT_GADAI){
                  
                        payload.append("jenisId", this.input.emas.jenisEmas.id)
                        payload.append("kondisi", "Emas")
                        payload.append("merkId", this.input.emas.merkEmas.id)
            
                        payload.append("jenisPerhiasan", this.formReject.jenisPerhiasan)
                        payload.append("karat", this.formReject.karat)
                        const inputBatu = this.input.emas.batu
                        const batu = Array.from(inputBatu, item => ({ ...item, ukuran: item.ukuran.value }));
                        
                        payload.append("berat", this.input.emas.beratKering)
                        payload.append("beratKering", this.input.emas.beratKering)
                        payload.append("gosokanHilang", this.gosok)
                        payload.append("adaCap", this.cap)
                        payload.append("adaKwitansi", this.kwitansi)
                        payload.append("dataBatu",JSON.stringify(batu))
        
                        if(this.checkBeratTambahan == true ){
                            payload.append("beratBatuTambahan",this.input.emas.beratTambahan)
                        }
                }
                else if (this.fromEmas == false){
                    payload.append("spekBarangId", this.dataPinjam.spekBarang)
                    payload.append("tipeId", this.activeTipe.id)
                    payload.append("kondisi", this.dataPinjam.perhitunganKondisi.name)
                    payload.append("imeiSn", this.formReject.imeiSn)

                    if (this.input.elek.tipe != null && this.input.elek.tipe.noModel != null) {
                        payload.append("modelNumber", this.input.elek.tipe.noModel)
                    }
                    if (!this.$helper.isNullOrEmpty(this.input.elek.modelNumber)) {
                        if (this.input.elek.modelNumber == 'Lainnya') {
                            payload.append("modelNumber", this.input.elek.modelNumberLainnya)
                        }
                        else {
                            payload.append("modelNumber", this.input.elek.modelNumber)
                        }
                    }
                }            
                payload.append("spesifikasi", this.formReject.spesifikasi)
            }
            payload.append("pinjamanMaksimal", (this.dataPinjam.maksimumPinjaman != undefined) ?this.dataPinjam.maksimumPinjaman :0)  
            payload.append("pinjamanKebutuhanNasabah", this.$helper.removeThousandSeparator(this.formReject.kebutuhanNasabah))
            
            let jsonFoto = []
            this.formReject.fotoPendukung.forEach(function (entry) {
                if (entry.activeFotoPendukungBase64 != null) {
                    jsonFoto.push(entry.activeFotoPendukungBase64)
                }
            })
            if (jsonFoto.length != 0) {
                payload.append("foto", JSON.stringify(jsonFoto))
            }
            
            this.isSubmitting = true
       
            if (this.fromEmas == true) {
                this.$axios.post("gadai-reject/emas/", json).then(() => {

                this.$helper.toastSucc(this, "Data berhasil di Input!")
                this.$bvModal.hide("konfirm-submit-reject")
                this.$bvModal.hide("modal-reject-gadai-emas")
                this.$bvModal.hide("modal-data-pinjaman")

                this.resetFormReject()
                this.reset()

                })   
                .catch(error => {
                    console.log(error);
                    this.isSubmitting = false
                    this.$helper.parseError(this, error)
                })
                .finally(() => this.isSubmitting = false)
            } else if ( this.input.elek.jenis == null && this.input.kendaraan.jenis == null && this.input.emas.jenisEmas == null ) {
                let jsonFoto = []
                    this.formReject.fotoPendukung.forEach(function (entry) {
                        if (entry.activeFotoPendukungBase64 != null) {
                            jsonFoto.push(entry.activeFotoPendukungBase64)
                        }
                    })
                    if (jsonFoto.length != 0) {
                        payload.append("foto", JSON.stringify(jsonFoto))
                    }
                let json = {
                            core : { 
                                    cabangId: this.cabangId,
                                    reasonId: this.formReject.alasan.id,
                                    namaNasabah: this.formReject.nasabah,
                                    noHpNasabah: (this.formReject.noHp != null || this.formReject.noHp != "") ? this.formReject.noHp : "-",
                                    keterangan: this.formReject.keteranganAlasan,
                                    pinjamanMaksimal:  (this.dataPinjam.maksimumPinjaman != undefined) ?this.dataPinjam.maksimumPinjaman :0,
                                    pinjamanKebutuhanNasabah: this.$helper.removeThousandSeparator(this.formReject.kebutuhanNasabah),
                                    isTipeTidakTerdaftar: this.formReject.isTipeTidakTerdaftar,
                                    namaTipeTidakTerdaftar: this.formReject.namaTipeTidakTerdaftar, // string apabila tipe tidak terdaftar
                                    foto: jsonFoto
                                },
                          
                                    jenisPerhiasan : this.formReject.jenisPerhiasan,
                                    karat : this.formReject.karat,
                                    jenisKemasanId: (this.input.emas.kemasanEmas != null) ?this.input.emas.kemasanEmas.id : null , 
                                    capId: (this.input.emas.capEmas != null && this.cap) ?this.input.emas.capEmas.id : null ,
                                    beratKering : this.formReject.beratKering,
                                    berat : this.formReject.beratKering,
                                    dataPerhiasan:null
                            }
                
                this.$axios.post("gadai-reject/emas-lainnya/", json).then(() => {

                this.$helper.toastSucc(this, "Data berhasil di Input!")
                this.$bvModal.hide("konfirm-submit-reject")
                this.$bvModal.hide("modal-reject-gadai-emas")

                this.resetFormReject()
                this.reset()

                })   
                .catch(error => {
                    console.log(error);
                    this.isSubmitting = false
                    this.$helper.parseError(this, error)
                })
                .finally(() => this.isSubmitting = false)
            } else if (this.IS_REJECT_GADAI){
                json.core = { 
                                cabangId: this.cabangId,
                                reasonId: this.formReject.alasan.id,
                                namaNasabah: this.formReject.nasabah,
                                noHpNasabah: (this.formReject.noHp != null || this.formReject.noHp != "") ? this.formReject.noHp : "-",
                                keterangan: this.formReject.keteranganAlasan,
                                pinjamanMaksimal:  (this.dataPinjam.maksimumPinjaman != undefined) ?this.dataPinjam.maksimumPinjaman :0,
                                pinjamanKebutuhanNasabah: this.$helper.removeThousandSeparator(this.formReject.kebutuhanNasabah),
                                isTipeTidakTerdaftar: this.formReject.isTipeTidakTerdaftar,
                                namaTipeTidakTerdaftar: this.formReject.namaTipeTidakTerdaftar, // string apabila tipe tidak terdaftar
                                foto: jsonFoto
                            },
                json.jenisPerhiasan = this.formReject.jenisPerhiasan,
                json.karat = this.formReject.karat,
                json.jenisKemasanId = (this.input.emas.kemasanEmas != null) ?this.input.emas.kemasanEmas.id : null , 
                json.capId = (this.input.emas.capEmas != null && this.cap) ?this.input.emas.capEmas.id : null ,
                json.beratKering = this.input.emas.beratKering,
                json.berat = this.formReject.beratKering,

                json.dataPerhiasan = json.dataEmas
                this.$axios.post("gadai-reject/emas-lainnya/", json).then(() => {
                this.$helper.toastSucc(this, "Data berhasil di Input!")
                this.$bvModal.hide("konfirm-submit-reject")
                this.$bvModal.hide("modal-reject-gadai-emas")
                this.$bvModal.hide("modal-data-pinjaman")

                this.resetFormReject()
                this.reset()

                })   
                .catch(error => {
                    console.log(error);
                    this.isSubmitting = false
                    this.$helper.parseError(this, error)
                })
                .finally(() => this.isSubmitting = false)
            }
            else{ 
                this.$axios.post("gadai-reject/", payload).then(() => {

                    this.$helper.toastSucc(this, "Data berhasil di Input!")
                    this.$bvModal.hide("konfirm-submit-reject")
                    this.$bvModal.hide("modal-reject-gadai")
                    this.$bvModal.hide("modal-data-pinjaman")
        
                    this.resetFormReject()
                    this.reset()

                })   
                .catch(error => {
                    console.log(error);
                    this.isSubmitting = false
                    this.$helper.parseError(this, error)
                })
                .finally(() => this.isSubmitting = false)
            }
         
        },

        tampilanCetak() {
            if (!this.validateMetodeGadai()) return
            this.isSubmitting = true;
            if (this.input.elek.jenis != null) {

                let payload = new FormData()
                if(this.anggota.id != null){
                    payload.append("nasabahId", this.anggota.id)
                }
                payload.append("jenisPinjamanId", 1) // MARK HARDCODE
                payload.append("jenisId", this.input.elek.jenis.id)
                payload.append("merkId", this.input.elek.merk.id)
                payload.append("tipeId", this.input.elek.tipe.id)
                payload.append("kondisiId", this.input.elek.kondisi)
                payload.append("cabangId", this.cabangId)
                if (this.input.elek.modelNumber != null) {
                    payload.append("modelNumber", (this.input.elek.modelNumber == 'Lainnya') ?this.input.elek.modelNumberLainnya :this.input.elek.modelNumber )
                }
                // Find whether to also append tahunId according to selection
                if (this.input.elek.tahun != null) {
                    payload.append("tahunId", this.input.elek.tahun);
                }
                // Append all checked spesifikasi
                for (let spek of this.input.elek.spesifikasiJenis) {
                    payload.append("spesifikasiId", spek);
                }
                for (let spek of this.input.elek.spesifikasiMerk) {
                    payload.append("spesifikasiId", spek);
                }
                if (!this.$helper.isNullOrEmpty(this.input.elek.noImei)) {
                    payload.append("imeiSn", this.input.elek.noImei)
                }
                // Do calculation
                if (!this.$helper.isNullOrEmpty(this.input.nilaiPinjaman)){
                    payload.append("jumlahPinjaman",parseInt(this.input.nilaiPinjaman.replace(/\./g, ''), 10))
                }
                if (this.input.metodeGadai == 'angsuran') payload.append("tenor", this.input.tenor)
                this.isSubmitting = true;
                this.$axios.post("gadai-crud/simulasi/elektronik/cetak", payload).then(response => {
                    this.urlTaksiran = this.$baseFilePath + response.data.name;
                    this.codeSimulasi = this.formatCodeSimulasi(response.data.id);
                    
                    this.$bvModal.show("modal-print");
                })
                    .catch(error => {
                    this.$helper.parseError(this, error);
                })
                    .finally(() => {
                    this.isSubmitting = false;
                });
            } else if (this.input.kendaraan.jenis != null) {
                let payload = new FormData()
                if(this.anggota.id != null){
                    payload.append("nasabahId", this.anggota.id)
                }
                
                payload.append("jenisPinjamanId", 2) // MARK HARDCODE
                payload.append("jenisId", this.input.kendaraan.jenis.id)
                payload.append("merkId", this.input.kendaraan.merk.id)
                payload.append("tipeId", this.input.kendaraan.tipe.id)
                payload.append("kondisiId", this.input.kendaraan.kondisi)
                payload.append("cabangId", this.cabangId)
                
                if(this.tipePinjamanKendaraan == "kendaraan") payload.append("bpkbOnly", false)
                else payload.append("bpkbOnly", true)
                // Find whether to also append tahunId according to selection
                if (this.input.kendaraan.tahun != null) {
                    payload.append("tahunId", this.input.kendaraan.tahun);
                }
                // Append all checked spesifikasi
                for (let spek of this.input.kendaraan.spesifikasiJenis) {
                    payload.append("spesifikasiId", spek);
                }
                for (let spek of this.input.kendaraan.spesifikasiMerk) {
                    payload.append("spesifikasiId", spek);
                }
                // Do calculation
                if (!this.$helper.isNullOrEmpty(this.input.nilaiPinjaman)){
                    payload.append("jumlahPinjaman",parseInt(this.input.nilaiPinjaman.replace(/\./g, ''), 10))
                }
                if (this.input.metodeGadai == 'angsuran') payload.append("tenor", this.input.tenor)
                this.isSubmitting = true;
                this.$axios.post("gadai-crud/simulasi/kendaraan/cetak", payload).then(response => {
                    this.urlTaksiran = this.$baseFilePath + response.data.name;
                    this.codeSimulasi = this.formatCodeSimulasi(response.data.id);
                    this.$bvModal.show("modal-print");
                })
                    .catch(error => {
                    this.$helper.parseError(this, error);
                })
                    .finally(() => {
                    this.isSubmitting = false;
                });
            } else {
                let json = {
                    cabangId : this.cabangId,
                    jumlahPinjaman: this.$helper.removeThousandSeparator(this.input.nilaiPinjaman),
                    core : {},
                    nasabahId: this.anggota != null ? this.anggota.id : null,
                    tenor: this.input.metodeGadai == 'angsuran' ? this.input.tenor : null
                }

                if (this.input.emas.jenisEmas.id == 251) {
                    json.core.jenisId = this.input.emas.jenisEmas.id
                    json.core.merkId = this.input.emas.merkEmas.id
                    json.core.tipeId = this.input.emas.tipeEmas.id
                    json.core.jenisKemasanId = (this.input.emas.kemasanEmas != null) ?this.input.emas.kemasanEmas.id : null 
                    json.core.capId = (this.input.emas.capEmas != null && this.cap) ?this.input.emas.capEmas.id : null 
                    json.core.beratKering = null 
                    json.core.dataPerhiasan = null 
                }
                
                if (this.input.emas.jenisEmas.id == 257) {
                    json.core.jenisId = this.input.emas.jenisEmas.id
                    json.core.merkId = this.input.emas.merkEmas.id
                    json.core.tipeId = this.input.emas.karatEmas.id
                    json.core.jenisKemasanId = (this.input.emas.kemasanEmas != null) ?this.input.emas.kemasanEmas.id : null 
                    json.core.capId = (this.input.emas.capEmas != null && this.cap) ?this.input.emas.capEmas.id : null 
                    json.core.beratKering = this.input.emas.beratKering 
                    json.core.dataPerhiasan = {
                        gosokanHilang : this.gosok,
                        adaCap : this.cap,
                        adaKwitansi : this.kwitansi,
                        beratTambahan : (this.checkBeratTambahan == true) ? this.input.emas.beratTambahan : null,
                        kelengkapan : this.input.emas.kelengkapanBarang, 
                        pointCapEmas : this.input.emas.pointCapEmas,
                        listBatu :  (this.input.emas.batu.length != null ) ? Array.from(this.input.emas.batu, item => ({ jumlah: item.jumlah, ukuran: item.ukuran.value })) : null,
                        listSpekEmas: this.input.emas.potonganTambahan,
                        adaLogoPerusahaan: this.isAdaMerkPerusahaan
                    } 
                }
                
                if (this.input.emas.jenisEmas.id == 261) {
                    json.core.jenisId = this.input.emas.jenisEmas.id
                    json.core.merkId = this.input.emas.merkEmas.id
                    json.core.tipeId = this.input.emas.tipeEmas.id
                    json.core.jenisKemasanId = (this.input.emas.kemasanEmas != null) ?this.input.emas.kemasanEmas.id : null 
                    json.core.capId = (this.input.emas.capEmas != null && this.cap) ?this.input.emas.capEmas.id : null 
                    json.core.beratKering = this.input.emas.beratKering 
                    json.core.dataPerhiasan = {
                        adaLogoPerusahaan: this.isAdaMerkPerusahaan
                    } 
                }
            
                this.$axios.post("gadai-emas/simulasi/cetak", json).then(response => {
                    this.urlTaksiran = this.$baseFilePath + response.data.name;
                    this.codeSimulasi = this.formatCodeSimulasi(response.data.id);
                    this.$bvModal.show("modal-print-emas");
                })
                .catch(error => {
                    this.$helper.parseError(this, error)
                })
                .finally(() => {
                    this.isSubmitting = false
                })
            }
        },

        validateMetodeGadai() {
            if (!this.installmentActive) this.input.metodeGadai = 'non_angsuran'
            if (this.$helper.isNullOrEmpty(this.input.metodeGadai)) {
                this.$helper.toastErr(this, "Metode gadai wajib dipilih terlebih dahulu.")
                return false
            }
            if (this.input.metodeGadai == 'angsuran' && this.$helper.isNullOrEmpty(this.input.tenor)) {
                this.$helper.toastErr(this, "Tenor wajib dipilih terlebih dahulu.")
                return false
            }
            return true
        },

        prosesGadai() {
            if (!this.validateMetodeGadai()) return

            const angsuran = {
                metodeGadai: this.input.metodeGadai,
                tenor: this.input.metodeGadai == 'angsuran' ? this.input.tenor : null,
                nilaiPinjaman: this.$helper.removeThousandSeparator(this.input.nilaiPinjaman),
            }

            console.log("cek",
                this.input.kendaraan.spesifikasiJenis);
            this.input.kendaraan.spek = this.input.kendaraan.spesifikasiJenis
            if (this.anggota.id != null) {
                localStorage.setItem("anggotaFromSimulasi", JSON.stringify(this.anggota))
            }
            else{
                localStorage.removeItem('anggotaFromSimulasi');
            }

            if(this.jenisPinjaman == JENIS.ELEKTRONIK) {
                localStorage.setItem("gadaiFromSimulasi", JSON.stringify({ ...this.input.elek, ...angsuran }))
                this.$router.push({ path: "/gadai/elektronik"})
            }
            else if(this.jenisPinjaman == JENIS.KENDARAAN) {
                let pajakMati = [ 
                                    'Pajak Mati (a/n Sendiri)',
                                    'Pajak Mati (a/n Orang lain)',
                                    'Pajak Mati (a/n SENDIRI)',
                                    'Pajak Mati (a/n ORANG LAIN)',
                                    'Pajak Mati (a/n Sendiri Pick Up)',
                                    'Pajak Mati (a/n Orang Lain Pick Up)',
                                    'Pajak Mati (a/n SENDIRI PICK UP)',
                                    'Pajak Mati (a/n ORANG LAIN PICK UP)'
                                ]
                let idPajak = []
                     
                for(var pajak of pajakMati){
                    let idx = this.optKendaraanSpekJenis.pengurangan.findIndex(item => item.name == pajak)
                    if (idx != -1) {
                        idPajak.push(this.optKendaraanSpekJenis.pengurangan[idx].id)
                    }
                }

                if (idPajak.length != 0) {
                    for(var idp of idPajak ){
                        this.input.kendaraan.spesifikasiJenis = this.input.kendaraan.spesifikasiJenis.filter(item => item != idp)
                    }
                }
                let datas = this.optKendaraanKondisi.find(item => item.value === this.input.kendaraan.kondisi);
                let regex = /(A\/N ORANG LAIN|A\/N SENDIRI)/;
                let match = datas.text.match(regex);

                datas.text = match ? match[0] : "";
                this.input.kendaraan.kendaraanKondisi = datas
                this.input.kendaraan.tanggalPajak = this.tanggalPajak
                this.input.kendaraan.spesifikasiJenis
                console.log("spek", this.input.kendaraan.spesifikasiJenis);
                
                localStorage.setItem("gadaiFromSimulasi", JSON.stringify({ ...this.input.kendaraan, ...angsuran }))
                this.$router.push({ path: "/gadai/kendaraan"})
            }
            else if(this.jenisPinjaman == JENIS.EMAS) {
                this.input.emas.cap = this.cap
                this.input.emas.kwitansi = this.kwitansi
                this.input.emas.gosok = this.gosok
                this.input.emas.karatOpt = this.karatOpt
                this.input.emas.isAdaMerkPerusahaan = this.isAdaMerkPerusahaan
                // this.input.emas.capEmas = (this.input.emas.capEmas != null && this.cap) ?this.input.emas.capEmas.id : null
                localStorage.setItem("gadaiFromSimulasi", JSON.stringify({ ...this.input.emas, ...angsuran }))
                this.$router.push({ path: "/gadai/emas"})
            }
        
        },

        roundPersen(id){
            if (id == 1) { 
                if( Number(this.input.emas.beratKering) > 1000){
                    this.input.emas.beratKering = Number(0).toFixed(1);
                }
                else{
                    this.input.emas.beratKering =  Number(this.input.emas.beratKering).toFixed(2);
                }
            }

            if (id == 2) {
                if( Number(this.input.emas.beratBasah) > 99){
                this.input.emas.beratBasah = Number(0).toFixed(1);
                }
                else{ 
                    this.input.emas.beratBasah = Number(this.input.emas.beratBasah).toFixed(2);
                }
            }

            if (id == 3) {
                if( Number(this.input.emas.beratTambahan) > 99){
                this.input.emas.beratTambahan = Number(0).toFixed(1);
                }
                else{ 
                    this.input.emas.beratTambahan = Number(this.input.emas.beratTambahan).toFixed(2);
                }
            }

            if (id == 4) {
                if( Number(this.formReject.beratKering) > 1000){
                this.formReject.beratKering = Number(0).toFixed(1);
                }
                else{ 
                    this.formReject.beratKering = Number(this.formReject.beratKering).toFixed(2);
                }
            }

            if (id == 5) {
                if( Number(this.input.emas.beratTambahan) > 99){
                this.input.emas.beratTambahan = Number(0).toFixed(1);
                }
                else{ 
                    this.input.emas.beratTambahan = Number(this.input.emas.beratTambahan).toFixed(2);
                }
            }

            if (id == 6) {
                if( Number(this.input.emas.beratKering) > 1000) {
                        this.input.emas.beratKering = Number(0).toFixed(1);
                    }
                else{
                    this.input.emas.beratKering = Number(this.input.emas.beratKering).toFixed(2);
                }
            }
		},

        modalSearchModel(){
            this.input.noModel
            this.model = []

            this.$bvModal.show("modal-search-model")
        },

        modelSelected(item){
            if (this.input.elek.jenis != null) {  
                this.optElekTipe = [];
                this.optElekTipe.push(item);
                this.input.elek.tipe = item
            }
            if (this.input.kendaraan.jenis != null) {   
                this.optKendaraanTipe = [];
                this.optKendaraanTipe.push(item);
                this.input.kendaraan.tipe = item
            }
            if (this.input.emas.jenisEmas != null) {   
                this.optTipeEmas = [];
                this.optCapEmas = [];
                this.optKemasanEmas = [];
                this.optElekTipe.push(item);
                this.input.emas.tipeEmas = item
            }
            this.$bvModal.hide("modal-search-model")
        },

        //FUNGSI SE

        openModalSE(se , jenis , isViewSE , kondisiSpek , idSpek){
            this.activeSE = se
            this.rows = se.length

            if(isViewSE == false){
                let payload = new FormData()

                let id = 0
                if(jenis == 'jenis'){
                    id = this.input.elek.jenis.id
                    payload.append("id",jenis+id)
                    payload.append("jenis", "jenis")
                }
                if(jenis == 'merk'){
                    id = this.input.elek.merkBarang.id
                    payload.append("id",jenis+id)
                    payload.append("jenis", "merk")
                }
                if(jenis == 'tipe'){
                    id = this.input.elek.tipeBarang.id
                    payload.append("id",jenis+id)
                    payload.append("jenis", "tipe")
                }
                if(jenis == 'kondisi'){
                    id = this.input.elek.tipeBarang.id
                    payload.append("id",jenis+id)
                    payload.append("jenis", "kondisi")
                }
                if(jenis == 'kelengkapan'){
                    id = this.input.elek.jenis.id
                    payload.append("id",jenis+id)
                    payload.append("jenis", "kelengkapan")
                }
                if(jenis == 'spesifikasiJenis'){
                    id = idSpek
                    payload.append("id","spesifikasi"+id)
                    payload.append("jenis", "spesifikasi")
                }
                if(jenis == 'spesifikasiMerk'){
                    id = idSpek
                    payload.append("id","spesifikasi"+id)
                    payload.append("jenis", "spesifikasi")
                }
                if(jenis == 'tahun'){
                    id = this.input.elek.tipeBarang.id
                    payload.append("id","tahun"+id)
                    payload.append("jenis", "tahun")
                }
                if(jenis == 'anggota'){
                    payload.append("id",'anggota')
                    payload.append("jenis", "anggota")
                }
                if(jenis == 'alasanRejectGadai'){
                    payload.append("id",'alasanRejectGadai')
                    payload.append("jenis", "alasanRejectGadai")
                }
                this.$axios.post(`surat-edaran/view`, payload).then(() => {
                    if(jenis == 'anggota'){
                        this.pdfReadAnggota = true
                    }
                    if(jenis == 'alasanRejectGadai'){
                        this.pdfReadAlasanRejectGadai = true
                    }
                    if(jenis == 'jenis'){
                        this.pdfReadJenis = true
                    }
                    if(jenis == 'merk'){
                        this.pdfReadMerk = true
                    }
                    if(jenis == 'tipe'){
                        this.pdfReadTipe = true
                    }
                    if(jenis == 'kondisi'){
                        this.pdfReadKondisi = true
                    }
                    if(jenis == 'tahun'){
                        this.pdfReadTahun = true
                    }
                    if(jenis == 'kelengkapan'){
                        this.pdfReadKelengkapan = true
                    }
                    if(jenis == 'spesifikasiJenis'){
                        if(kondisiSpek == 'penambahanSpekJenis'){
                            let idx = this.optElekSpekJenis.penambahan.findIndex(item => item.id == idSpek)
                            this.optElekSpekJenis.penambahan[idx].isViewSE = true
                        }
                        if(kondisiSpek == 'penguranganSpekJenis'){
                            let idx = this.optElekSpekJenis.pengurangan.findIndex(item => item.id == idSpek)
                            this.optElekSpekJenis.pengurangan[idx].isViewSE = true
                        }
                    }
                    if(jenis == 'spesifikasiMerk'){
                        if(kondisiSpek == 'penambahanSpekMerk'){
                            let idx = this.optElekSpekMerk.penambahan.findIndex(item => item.id == idSpek)
                            this.optElekSpekMerk.penambahan[idx].isViewSE = true
                        }
                        if(kondisiSpek == 'penguranganSpekMerk'){
                            let idx = this.optElekSpekMerk.pengurangan.findIndex(item => item.id == idSpek)
                            this.optElekSpekMerk.pengurangan[idx].isViewSE = true
                        }
                    }
                })
            }
            

            this.$bvModal.show("modal-SE")
        },

        onPageChange(){
            let prevLimit = null
            let limit = null
            prevLimit = (this.currentPage-1) * 1 + 1
            limit = (this.currentPage-1) * 1 + 1
            if(limit > this.rows) limit = this.rows
            this.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rows + " entri"
        },
   
        openModalJasa(){
            this.$bvModal.show("modal-jasa-emas")
        },

        reset(){
            this.input = {
                elek: {
                    jenis: null,
                    jenisName: null,
                    merk: null,
                    merkName: null,
                    tipe: null,
                    tipeName: null,
                    tahun: null,
                    kondisi: null,
                    spesifikasiJenis: [],
                    spesifikasiMerk: [],
                    noImei: "",
                    modelNumber: null,
                    modelNumberLainnya: null,
                },
                kendaraan: {
                    bpkb: null,
                    jenis: null,
                    jenisName: null,
                    merk: null,
                    merkName: null,
                    tipe: null,
                    tipeName: null,
                    tahun: null,
                    kondisi: null,
                    spesifikasiJenis: [],
                    spesifikasiMerk: []
                },
                emas: {
                    jenisEmas:null,
                    merkEmas:null,
                    tipeEmas:null,
                    karatEmas: null,
                    spesifikasiJenis: [],
                    kelengkapanBarang: [],
                    beratKering: null,
                    beratBasah: null,
                    jumlah : 1,
                    keterangan: "",
                    promo: [],
                    nilaiPinjaman: 0,
                    warnaBatu: null,
                    
                    batu:[],
                    beratTambahan: null,
                    potonganTambahan:[],

                    capEmas : null,
                    kemasanEmas : null,
                    pointCapEmas : null,
                },
                nilaiPinjaman: null,
                metodeGadai: null,
                tenor: null,
                isPajakValid : false,
            }
            this.karatOpt = []
            
            this.formReject = {
                alasan : null,
                keteranganAlasan : "",
                nasabah: null,
                noHp: null,
                imeiSn: null,
                kebutuhanNasabah: null,
                namaTipeTidakTerdaftar:null,
                isTipeTidakTerdaftar:false
            },

            this.activeKondisi = null
        },

        toggleBusy() {
            if(this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        formatCodeSimulasi(codeSimulasi) {
          return codeSimulasi.toString().padStart(6, '0');
        },
        copyToClipboard(text) {
            navigator.clipboard.writeText(text).then(() => {
                alert('Kode berhasil disalin!')
            }).catch(err => {
                this.$helper.parseError(this, err)
            })
        },

        masaBerlaku(selectedDate) {
    if (!selectedDate) return;
    const today = new Date().toISOString().split("T")[0];
    const isFutureDate = new Date(selectedDate) > new Date(today); // Cek apakah tanggal lebih dari hari ini

    const kendaraanKondisiObj = this.optKendaraanKondisi.find(
        item => String(item.value) === String(this.input.kendaraan.kondisi)
    );
    const kendaraanKondisi = kendaraanKondisiObj ? kendaraanKondisiObj.text.toUpperCase() : "";

    let existingIds = Array.isArray(this.input.kendaraan.spesifikasiJenis)
        ? [...this.input.kendaraan.spesifikasiJenis] // Copy array biar tidak mutasi langsung
        : [];

    console.log("Kondisi Kendaraan:", kendaraanKondisi);
    console.log("Sebelum update, existingIds:", existingIds);

    // **Mapping kondisi ke array nama checkbox**
    const kondisiMapping = {
        "A/N SENDIRI": this.input.kendaraan.tipe.name === "Pick Up"
            ? ["Pajak Mati (a/n Sendiri Pick Up)", "Pajak Mati (a/n SENDIRI PICK UP)"]
            : ["Pajak Mati (a/n Sendiri)", "Pajak Mati (a/n SENDIRI)"],

        "A/N ORANG LAIN": this.input.kendaraan.tipe.name === "Pick Up"
            ? ["Pajak Mati (a/n Orang lain Pick Up)", "Pajak Mati (a/n ORANG LAIN PICK UP)"]
            : ["Pajak Mati (a/n Orang lain)", "Pajak Mati (a/n ORANG LAIN)"]
    };

    // **Ambil semua ID pajak mati untuk Pick Up & Non Pick Up**
    const allPajakMatiIds = this.optKendaraanSpekJenis.pengurangan
        .filter(item => Object.values(kondisiMapping).flat().includes(item.name))
        .map(item => item.id);

    console.log("All Pajak Mati IDs:", allPajakMatiIds, this.optKendaraanSpekJenis.pengurangan);

    // **Jika tanggal > hari ini, hapus semua pajak mati**
    if (isFutureDate) {
        console.log("Tanggal masa berlaku di masa depan, menghapus pajak mati...");
        this.input.kendaraan.spesifikasiJenis = existingIds.filter(id => !allPajakMatiIds.includes(id));
        console.log("Setelah update (future date), spesifikasiJenis:", this.input.kendaraan.spesifikasiJenis);
        return;
    }

    // **Jika tanggal valid (≤ hari ini) & kondisi berubah, update pajak mati**
    const selectedKeyword = Object.keys(kondisiMapping).find(key => kendaraanKondisi.includes(key));

    console.log("Selected keyword:", selectedKeyword);

    if (selectedKeyword) {
        const namaCheckboxes = kondisiMapping[selectedKeyword];
        
        // Ambil ID dari semua checkbox yang sesuai dengan kondisi kendaraan
        const newIds = this.optKendaraanSpekJenis.pengurangan
            .filter(item => namaCheckboxes.includes(item.name))
            .map(item => item.id);

        console.log("New Pajak Mati IDs to add:", newIds);

        // Hapus pajak mati lama, tambahkan yang sesuai
        existingIds = existingIds.filter(id => !allPajakMatiIds.includes(id)); // Hapus semua pajak mati lama
        this.input.kendaraan.spesifikasiJenis = [...new Set([...existingIds, ...newIds])]; // Tambahkan yang baru
        
        console.log("Setelah update (kondisi berubah), spesifikasiJenis:", this.input.kendaraan.spesifikasiJenis);
    } else {
        console.log("Tidak ada kondisi yang cocok untuk dicentang.");
    }
},
formatTanggal(input) {
  const date = new Date(input);
  
  const tanggal = date.getDate();
  const bulan = date.toLocaleString('id-ID', { month: 'long' });
  const tahun = date.getFullYear();
  
  const jam = String(date.getHours()).padStart(2, '0');
  const menit = String(date.getMinutes()).padStart(2, '0');

  return `${tanggal} ${bulan} ${tahun}, ${jam}.${menit}`;
},
async cekGadaiBerjalan(id, tabIndex) {
    try {
        const response = await this.$axios.get("gadai-crud/kendaraan/berjalan/" + id);
        if (response.data.id == 1 && tabIndex == 1) {
            return true; 
        } else {
            return false; 
        }
    } catch (error) {
        console.error("Gagal mengecek gadai berjalan:", error);
        return false;
    }
},
async handleTabChange(tab) {
    if (tab == 1 && this.anggota.id) {
        const adaGadai = await this.cekGadaiBerjalan(this.anggota.id, tab);
        if (adaGadai) {
            this.$bvModal.hide("modal-pilih-anggota");
            this.$bvModal.show("modal-simulasi-bpkb");
            this.resetAnggota();
        }
    }

    if (tab === 1) {
        this.getPlatWilayah();
    }
},
resetAnggota() {
    this.anggota = {
        id: null,
        nama: "-",
        no: "-",
        noMember: null,
        jenisBarang: "-",
        jenisIdentitas: "-",
        noIdentitas: "-",
        noHp: "-",
        noRumah: "-",
        alamat: "-",
        detail: null,
        isComplete: false,
        shouldUpdate: false,
        fotoKtp: "",
    };
},
        getPlatWilayah() {
            this.statePlatWilayah.isError = false;
            this.statePlatWilayah.data = [];

            this.statePlatWilayah.isLoading = true;
            this.$axios.get(`gadai/kode-wilayah-gadai-kendaraan`).then(response => {
                const plat = response.data.map((item) => item.name)
                this.statePlatWilayah.data = plat
            }).catch(error => {
                this.$helper.parseError(this, error)
                this.statePlatWilayah.isError = true;
            }).finally(() => {
                this.statePlatWilayah.isLoading = false;
            });
        },
        formatPlatWilayah(items) {
            if (items.length === 0) {
                return "";
            }
            
            if (items.length === 1) {
                return items[0];
            }
            
            const allButLast = items.slice(0, -1);
            const lastItem = items[items.length - 1];
            
            return `${allButLast.join(', ')} dan ${lastItem}.`;
        },

        openPreview(foto){
            this.activeFotoPreview = foto
            this.$bvModal.show("modal-preview-gadai")
        },
        redirectToWhatsapp(number) {
            if (!number || number === '-' || number.trim() === '') {
                return;
            }

            const formatted = number.startsWith('0') 
            ? '62' + number.substring(1) 
            : number;

            window.open(`https://wa.me/${formatted}`, '_blank');
        },
        onCopyUrlWhatsApp(number) {
            if (!number || number === '-' || number.trim() === '') {
                console.error('Nomor HP tidak valid untuk disalin.');
                return;
            }

            const formatted = number.startsWith('0') 
                ? '62' + number.substring(1) 
                : number;
            
            const urlToCopy = `https://wa.me/${formatted}`;

            navigator.clipboard.writeText(urlToCopy).then(() => {
                this.$helper.toastSucc(this, "Link WhatsApp berhasil disalin!")
            }).catch(err => {
                this.$helper.toastErr(this, "Gagal menyalin link.")
                console.error('Gagal menyalin teks: ', err);
            });
        },
        onBlurTanggalPajak() {
            const result = this.$helper.validateBatasMasaPajak(this.tanggalPajak);

            if (!result.valid) {
                this.$helper.toastErr(this, result.message);
                return;
            }
        },
        getMerkBarang() {
            const idJenisBarang = this.input.elek.jenis.id;
            this.optElekMerk = [];
            this.stateMerkBarang.isLoading = true;
            this.$axios.get(`barang-merk/jenis/${idJenisBarang}`).then(response => {
                this.optElekMerk = response.data
            }).catch((error) => {
                const errorMessage = error.response.data.reason || error.response.data.error;
                this.stateMerkBarang.error = errorMessage;
            }).finally(() => {
                this.stateMerkBarang.isLoading = false;
            }) 
        },
        getTipeBarang() {
            const idMerkBarang = this.input.elek.merk.id;
            this.optElekTipe = [];
            this.stateTipeBarang.isLoading = true;
            this.$axios.get(`barang-tipe-v2/merk/${idMerkBarang}`).then(response => {
                this.optElekTipe = response.data.types;
                if (response.data.models.length == 0) {
                    this.showSearchModel = true
                } else {
                    this.showSearchModel = false
                    this.optModel = response.data.models;
                    this.optModel.push('Lainnya')
                }
            }).catch((error) => {
                const errorMessage = error.response.data.reason || error.response.data.error;
                this.stateTipeBarang.error = errorMessage;
            }).finally(() => {
                this.stateTipeBarang.isLoading = false;
            })
        },
        getGradeBarang() {
            const idTipeBarang = this.input.elek.tipe.id;
            this.optElekKondisi = [];
            this.stateGradeBarang.isLoading = true;
            this.$axios.get(`barang-tipe-v2/kondisi/${idTipeBarang}`).then(response => {
                this.optElekKondisi = response.data.filter(item => item.isActive == true)
                this.optElekKondisi = this.optElekKondisi.map(item => {
                    return { value: item.id, text: item.name }
                })
            }).catch((error) => {
                const errorMessage = error.response.data.reason || error.response.data.error;
                this.stateGradeBarang.error = errorMessage;
            }).finally(() => {
                this.stateGradeBarang.isLoading = false;
            })
        },
        getSpesifikasiJenisBarang() {
            const idJenisBarang = this.input.elek.jenis.id;
            this.optElekSpekJenis.penambahan = []
            this.optElekSpekJenis.pengurangan = []
            this.stateSpesifikasiJenisBarang.isLoading = true;
            this.$axios.get(`barang-jenis/spesifikasi?jenisId=${idJenisBarang}`).then(response => {
                this.optElekSpekJenis = response.data;
            }).catch((error) => {
                const errorMessage = error.response.data.reason || error.response.data.error;
                this.stateSpesifikasiJenisBarang.error = errorMessage;
            }).finally(() => {
                this.stateSpesifikasiJenisBarang.isLoading = false;
            })
        },
        getSpesifikasiMerkBarang() {
            const idMerkBarang = this.input.elek.merk.id;
            this.optElekSpekMerk.penambahan = [];
            this.optElekSpekMerk.pengurangan = [];
            this.stateSpesifikasiMerkBarang.isLoading = true;

            this.$axios.get(`barang-merk/spesifikasi?merkId=${idMerkBarang}`).then(response => {
                let pengurangan = response.data.pengurangan.filter(item => item.isActive == true)
                let penambahan = response.data.penambahan.filter(item => item.isActive == true)
                this.optElekSpekMerk.penambahan = penambahan
                this.optElekSpekMerk.pengurangan = pengurangan
            }).catch((error) => {
                const errorMessage = error.response.data.reason || error.response.data.error;
                this.stateSpesifikasiMerkBarang.error = errorMessage;
            }).finally(() => {
                this.stateSpesifikasiMerkBarang.isLoading = false;
            })
        },
        getMerkKendaraan() {
            const idJenisKendaraan = this.input.kendaraan.jenis.id;
            this.optKendaraanMerk = [];
            this.stateMerkKendaraan.isLoading = true;

            this.$axios.get(`barang-merk/jenis/${idJenisKendaraan}`).then((response) => {
                this.optKendaraanMerk = response.data;
            }).catch((error) => {
                const errorMessage = error.response.data.reason || error.response.data.error;
                this.stateMerkKendaraan.error = errorMessage;
            }).finally(() => {
                this.stateMerkKendaraan.isLoading = false;
            }) 
        },
        getTipeKendaraan() {
            const idMerkKendaraan = this.input.kendaraan.merk.id;
            this.optKendaraanTipe = [];
            this.stateTipeKendaraan.isLoading = true;

            this.$axios.get(`barang-tipe-v2/merk/${idMerkKendaraan}`).then((response) => {
                this.showSearchModel = false;
                this.optKendaraanTipe = response.data.types;
            }).catch((error) => {
                const errorMessage = error.response.data.reason || error.response.data.error;
                this.stateTipeKendaraan.error = errorMessage;
            }).finally(() => {
                this.stateTipeKendaraan.isLoading = false;
            })
        },
        getTahunKendaraan() {
            const idTipeKendaraan = this.input.kendaraan.tipe.id;
            this.optKendaraanTahun = [];
            this.stateTahunKendaraan.isLoading = true;

            this.$axios.get(`barang-tipe-v2/barang-tahun/${idTipeKendaraan}`).then((response) => {
                for (var x of response.data) {
                    if (x.isActive == true) {
                        this.optKendaraanTahun.push({
                            value: x.id,
                            text: x.tahun,
                        });
                    }
                }
            }).catch((error) => {
                const errorMessage = error.response.data.reason || error.response.data.error;
                this.stateTahunKendaraan.error = errorMessage;
            }).finally(() => {
                this.stateTahunKendaraan.isLoading = false;
            })
        },
        getGradeKendaraan() {
            const idTipeKendaraan = this.input.kendaraan.tipe.id;
            this.optKendaraanKondisi = [];
            this.stateGradeKendaraan.isLoading = true;

            this.$axios.get(`barang-tipe-v2/kondisi/${idTipeKendaraan}`).then(response => {
                this.optKendaraanKondisi = response.data
                    .filter(item => item.isActive)
                    .map(item => ({ value: item.id, text: item.name }));
            }).catch((error) => {
                const errorMessage = error.response.data.reason || error.response.data.error;
                this.stateGradeKendaraan.error = errorMessage;
            }).finally(() => {
                this.stateGradeKendaraan.isLoading = false;
            })
        },
        getSpesifikasiJenisKendaraan() {
            const idJenisKendaraan = this.input.kendaraan.jenis.id;
            this.optKendaraanSpekJenis.penambahan = [];
            this.optKendaraanSpekJenis.pengurangan = [];
            this.stateSpesifikasiJenisKendaraan.isLoading = true;

            this.$axios.get(`barang-jenis/spesifikasi?jenisId=${idJenisKendaraan}`).then(response => {
                this.optKendaraanSpekJenis.penambahan = response.data.penambahan.filter((item) => item.isActive);
                this.optKendaraanSpekJenis.pengurangan = response.data.pengurangan.filter((item) => item.isActive);
            }).catch((error) => {
                const errorMessage = error.response.data.reason || error.response.data.error;
                this.stateSpesifikasiJenisKendaraan.error = errorMessage;
            }).finally(() => {
                this.stateSpesifikasiJenisKendaraan.isLoading = false;
            })
        },
        getSpesifikasiMerkKendaraan() {
            const idMerkKendaraan = this.input.kendaraan.merk.id;
            this.optKendaraanSpekMerk.penambahan = [];
            this.optKendaraanSpekMerk.pengurangan = [];
            this.stateSpesifikasiMerkKendaraan.isLoading = true;

            this.$axios.get(`barang-merk/spesifikasi?merkId=${idMerkKendaraan}`).then((response) => {
                this.optKendaraanSpekMerk.penambahan = response.data.penambahan.filter(item => item.isActive)
                this.optKendaraanSpekMerk.pengurangan = response.data.pengurangan.filter(item => item.isActive)
            }).catch((error) => {
                const errorMessage = error.response.data.reason || error.response.data.error;
                this.stateSpesifikasiMerkKendaraan.error = errorMessage;
            }).finally(() => {
                this.stateSpesifikasiMerkKendaraan.isLoading = false;
            })
        },
        getMerkEmas() {
            const idJenisEmas = this.input.emas.jenisEmas.id
            this.stateMerkEmas.isLoading = true;
            this.optMerkEmas = [];
            
            this.$axios.get(`barang-merk/jenis/${idJenisEmas}`).then(response => {
                this.optMerkEmas = response.data
                if (this.optMerkEmas.length === 1 && this.input.emas.merkEmas == null ) {
                    this.input.emas.merkEmas = this.optMerkEmas[0]
                }
            }).catch((error) => {
                const errorMessage = error.response.data.reason || error.response.data.error;
                this.stateMerkEmas.error = errorMessage;
            }).finally(() => {
                this.stateMerkEmas.isLoading = false;
            }) 
        },
        getTipeEmas() {
            const idMerkEmas = this.input.emas.merkEmas.id
            this.stateTipeEmas.isLoading = true;
            this.optTipeEmas = [];

            this.$axios.get(`barang-tipe-v2/merk/${idMerkEmas}?sortByBerat=true`).then((response) => {
                this.optTipeEmas = response.data.types;
            }).catch((error) => {
                const errorMessage = error.response.data.reason || error.response.data.error;
                this.stateTipeEmas.error = errorMessage;
            }).finally(() => {
                this.stateTipeEmas.isLoading = false;
            })
        },
        validateAdaMerkPerusahaanInRetro() {
            const merkEmas = this.input.emas.merkEmas
            if (merkEmas && merkEmas.name.includes('Non Antam')) {
                this.isAdaMerkPerusahaan = false;
            } else {
                this.isAdaMerkPerusahaan = true;
            }
        }
    },
    computed: {
        installmentActive() {
            return !!(this.$store.state.cabang && this.$store.state.cabang.installmentActive)
        },
        angsuranPerBulan() {
            return this.jadwalAngsuran.length > 0 ? this.jadwalAngsuran[0].cicilan : 0
        },
        optionsTenor() {
            const tenor = { [JENIS.ELEKTRONIK]: [3, 6], [JENIS.KENDARAAN]: [3, 6, 12, 18, 24] }[this.jenisPinjaman] || [3, 6, 12]
            return tenor.map(value => ({ value, text: `${value} Bulan` }))
        },
        IS_NON_ANTAM() {
            const merkEmas = this.input.emas.merkEmas
            return !!(merkEmas && merkEmas.name.includes('Non Antam'))
        },
        IS_REJECT_GADAI() {
            const jenisEmas = this.input.emas.jenisEmas;
            if (jenisEmas && jenisEmas.id == enumJenisEmas.PERHIASAN) {
                return this.gosok && (!this.cap || !this.isAdaMerkPerusahaan)
            }

            return false
        },
    },
    watch: {
        'input.metodeGadai': function (newVal) {
            if (newVal != 'angsuran') {
                this.input.tenor = null;
                this.jadwalAngsuran = [];
                this.showJadwalAngsuran = false;
            }
        },

        'input.tenor': function (newVal) {
            this.jadwalAngsuran = [];
            this.showJadwalAngsuran = false;
            if (this.$helper.isNullOrEmpty(newVal)) {
                return;
            }
            this.getSimulasiAngsuran();
        },

        'input.elek.noImei': function (newVal){
            this.input.elek.noImei = newVal.replace(/\s/g, '');
        },

        "formReject.kebutuhanNasabah": function(newValue) {
            const result = newValue.replace(/^0+/,'').replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.$nextTick(() => this.formReject.kebutuhanNasabah = result)
        },

        "input.elek.jenis": function (newVal) {
            this.optElekMerk = [];
            this.input.elek.merk = null;
            this.optElekSpekJenis = { penambahan: [], pengurangan: [] };
            this.input.elek.spesifikasiJenis = [];
            this.seMerk = null
            this.seTipe = null
            this.input.elek.noImei = ""
            if (newVal == null) {
                return;
            }
            // Lookup Merk
            this.getMerkBarang();

             // Loojup SE jenis
             this.$axios.get(`barang-jenis/${newVal.id}`).then(response => {
                    if(response.data.suratEdaran.length != 0){
                        this.seJenis = response.data.suratEdaran
                        
                        for(var se of this.seJenis){
                            if(se.isViewSE == "false"){
                                this.pdfReadJenis = false
                            }
                        }
                    }else{
                        this.seJenis = null
                    }
                })

            // Lookup Spek Jenis
            this.getSpesifikasiJenisBarang();
        },
        "input.elek.merk": function (newVal) {
            this.optElekTipe = [];
            this.input.elek.tipe = null;
            this.optElekSpekMerk = { penambahan: [], pengurangan: [] };
            this.input.elek.spesifikasiMerk = [];
            this.showSearchModel = false
            this.input.elek.modelNumber = null
            if (newVal == null) {
                return;
            }
            // Lookup Tipe
            this.getTipeBarang();

            // Lookup Spek Merk
            this.getSpesifikasiMerkBarang();
        },
        "input.elek.tipe": function (newVal) {
            this.tipeCreate = null
            this.optElekTahun = [];
            this.input.elek.tahun = null;
            this.optElekKondisi = [];
            this.input.elek.kondisi = null;
            if (newVal == null) {
                return;
            }
           
            this.$axios.get(`barang-tipe-v2/${newVal.id}`).then(response => {
                let date = null
                if(response.data.createdAt != null){
                    date = response.data.createdAt
                    this.tipeCreate =  this.$helper.formatTanggalDMY(date)
                }else{
                    this.tipeCreate = null
                }

                    if (response.data.hasTahun == true) {
                        // Lookup Tahun
                        this.$axios.get(`barang-tipe-v2/barang-tahun/${newVal.id}`).then(response => {
                            for (var x of response.data) {
                                if (x.isActive == true) {
                                    this.optElekTahun.push({
                                        value: x.id,
                                        text: x.tahun
                                    })
                                }
                            }
                        })
                    }
                })
            // Lookup Foto Tipe Barang Elektronik
            this.$axios.get(`barang-tipe-v2/${newVal.id}`).then(response => {
                this.fotoTipeBarangElek = response.data.foto;
            })
            
            // Lookup Kondisi
            this.getGradeBarang();
        },
        "input.kendaraan.jenis": function (newVal) {
            this.optKendaraanMerk = [];
            this.input.kendaraan.merk = null;
            this.optKendaraanSpekJenis = { penambahan: [], pengurangan: [] };
            this.input.kendaraan.spesifikasiJenis = [];
            if (newVal == null) {
                return;
            }
            // Lookup Merk
            this.getMerkKendaraan();

            // Lookup Spek Jenis
            this.getSpesifikasiJenisKendaraan();
        },
        "input.kendaraan.merk": function (newVal) {
            this.optKendaraanTipe = [];
            this.input.kendaraan.tipe = null;
            this.optKendaraanSpekMerk = { penambahan: [], pengurangan: [] };
            this.input.kendaraan.spesifikasiMerk = [];
            if (newVal == null) {
                return;
            }
            // Lookup Tipe
            this.getTipeKendaraan();
            // Lookup Spek Merk
            this.getSpesifikasiMerkKendaraan();
        },

        "input.kendaraan.tipe": function (newVal) {
            this.optKendaraanTahun = [];
            this.input.kendaraan.tahun = null;
            this.optKendaraanKondisi = [];
            this.input.kendaraan.kondisi = null;
            if (newVal == null) {
                return;
            }
            this.isLoadingHasTahunKendaraan = true;
            this.$axios.get(`barang-tipe-v2/${newVal.id}`).then(response => {
                    if (response.data.hasTahun == true) {
                        // Lookup Tahun
                        this.getTahunKendaraan();
                    }
            })
            .finally(() => {
                this.isLoadingHasTahunKendaraan = false;
            })
            // Lookup Foto Tipe Barang Elektronik
            this.$axios.get(`barang-tipe-v2/${newVal.id}`).then(response => {
                    this.fotoTipeBarangKend = response.data.foto;
                })
            // Lookup Kondisi
            this.getGradeKendaraan();
        },

        "input.emas.jenisEmas": function(newVal){
  
        if (this.shouldResetSelections == true) {
            
            this.input.emas.merkEmas = null
            this.input.emas.tipeEmas = null
            this.input.emas.capEmas = null
            this.input.emas.kemasanEmas = null
            this.optMerkEmas = []
            this.optTipeEmas = []
            this.optCapEmas = []
            this.optKemasanEmas = []
            this.input.emas.beratKering = null
            this.input.emas.beratBasah = null
            this.input.emas.warnaBatu = null
            
            this.input.emas.spesifikasiJenis = []
            this.optKelengkapanBarang = []
            this.input.emas.kelengkapanBarang = []
            
            this.optPromo = []
            this.input.emas.promo = []
            this.isPromoRetrieved = false
            
            this.seJenis = null,
            this.seMerk = null,
            this.seTipe = null,
            this.seWarnaBatu = null
            this.seKelengkapan = null
            
            this.karat = null
            this.karatStatus = null
            this.input.emas.karatEmas = null
            this.karatOpt = []
            this.isAdaMerkPerusahaan = false;
        }
            
        if(newVal == null) {return}

        if(newVal.id != null){
            this.getMerkEmas();
            
            // Loojup SE jenis
            this.$axios.get(`barang-jenis/${newVal.id}`).then(response => {
                if(response.data.suratEdaran.length != 0){
                    this.seJenis = response.data.suratEdaran
                    
                    for(var se of this.seJenis){
                        if(se.isViewSE == "false"){
                            this.pdfReadJenis = false
                        }
                    }
                }else{
                    this.seJenis = null
                }
            })

            this.warnaBatuOpt = []
                // Lookup Spek Warna Batu
            this.$axios.get(`barang-jenis/spesifikasi?jenisId=${newVal.id}`).then(response => {
            
                let data = response.data
                if(data.pengurangan.length != 0){
                    for(var item of data.pengurangan){
                        this.warnaBatuOpt.push(item)
                    }
                }
                if (data.penambahan.length != 0) {
                    for(var item of data.penambahan){
                        this.warnaBatuOpt.push(item)
                    }
                }
                this.warnaBatuOpt.sort((a, b) => a.name.localeCompare(b.name));
                
            })

            // Lookup Kelengkapan Barang
            this.$axios.get(`barang-jenis/kelengkapan?jenisId=${newVal.id}`).then(response => {
                this.optKelengkapanBarang = []
                for (var x of response.data) {
                    if (x.isActive == true) {
                        this.optKelengkapanBarang.push({
                            id: x.id,
                            name: x.name,
                            se : (x.suratEdaran.length != 0) ?x.suratEdaran :null  
                        })
                    }
                }          
            })

            // LookUP Se Kelengkapan
            this.$axios.get('/surat-edaran/list/?menu=kelengkapan'+newVal.id+'&jenis=kelengkapan').then(response => {
                if(response.data.length !=0 ){
                        this.seKelengkapan = response.data
                        for(var file of this.seKelengkapan){
                            if(file.isViewSE == "false"){
                                this.pdfReadKelengkapan = false
                            }
                        }
                    }   
            })
        }
        },

        "input.emas.merkEmas" : function(newVal){

        if (this.shouldResetSelections == true) {
            
            this.input.emas.tipeEmas = null
            this.input.emas.capEmas = null
            this.input.emas.kemasanEmas = null
            this.input.emas.pointCapEmas = null
            
            this.optPromo = []
            this.input.emas.promo = []
            this.isPromoRetrieved = false
            this.optTipeEmas = []
            this.optCapEmas = []
            this.optKemasanEmas = []
        }
        this.shouldResetSelections = true
        if(newVal == undefined) {return}
            // Lookup Tipe
        if(newVal.id != undefined){
            
            this.$axios.get(`barang-merk/${newVal.id}`).then(response => {

                    if(response.data.suratEdaran.length != 0){
                        this.seMerk = response.data.suratEdaran
                        for(var se of this.seMerk){
                            if(se.isViewSE == "false"){
                                this.pdfReadMerk = false
                            }
                        }
                    }else{
                        this.seMerk = null
                    }

                    if(response.data.kondisi[0].suratEdaran.length != 0){
                        let suratEdaranKondisi = []
                        for(var se of response.data.kondisi[0].suratEdaran){
                            suratEdaranKondisi.push(se)
                                if(se.isViewSE == "false"){
                                    this.pdfReadKondisi = false
                                }
                        }

                        this.seKondisi = suratEdaranKondisi
                        this.seKondisiDariMerk = true
                    }else{
                        this.seKondisi = null
                    }
                })
                
                this.getTipeEmas();
                
                this.$axios.get(`cap-emas/selections?merkId=${newVal.id}`).then(response => {
                    this.optCapEmas = response.data
                })
                
                this.$axios.get(`kemasan-emas/selections?merkId=${newVal.id}`).then(response => {
                    this.optKemasanEmas = response.data
                })

                if (this.input.emas.jenisEmas.id == enumJenisEmas.LMRETRO) {
                    this.validateAdaMerkPerusahaanInRetro();
                }
        }

        },

        'input.emas.tipeEmas': function (newVal) {

        if (this.shouldResetSelections == true) {
            this.optPromo = []
            this.input.emas.promo = []
            this.isPromoRetrieved = false
        }
        
        this.shouldResetSelections = true
        
        if (newVal == null) { return }

        if (newVal != null) {
            this.input.emas.pointCapEmas = null
            this.$axios.get(`barang-tipe-v2/${newVal.id}`).then(response => {
                let date = null
                if(response.data.createdAt != null){
                    date = response.data.createdAt
                    this.tipeCreate =  this.$helper.formatTanggalDMY(date)
                }else{
                    this.tipeCreate = null
                }
                if(response.data.suratEdaran.length != 0){
                    let suratEdaran = []
                    let suratEdaranKondisi = []
                    let suratEdaranTahun = []
                        for(var se of response.data.suratEdaran){
                        if(se.jenis == null || se.jenis == "tipe"){
                            suratEdaran.push(se)
                            if(se.isViewSE == "false"){
                                this.pdfReadTipe = false
                            }
                        }
                        if(se.jenis == "kondisi"){
                            suratEdaranKondisi.push(se)
                            if(se.isViewSE == "false"){
                                this.pdfReadKondisi = false
                            }
                            this.seKondisiDariMerk = false
                        }
                        if(se.jenis == "tahun"){
                            suratEdaranTahun.push(se)                       
                            if(se.isViewSE == "false"){                             
                                this.pdfReadTahun = false
                            }
                        }
                    }
                    this.seTipe = suratEdaran
                    if(suratEdaranKondisi != null && suratEdaranKondisi.length != 0){
                        this.seKondisi = suratEdaranKondisi
                    }
                    this.seTahun = suratEdaranTahun
                    this.showSeKondisi = true
                }else{
                    this.seTipe = null
                }
                
                if(response.data.berat != null){
                    this.input.emas.tipeEmas.berat = response.data.berat
                }
            })
        }
        },

        "input.emas.warnaBatu" : function(newVal){
        if (newVal == null) { return }
        if(newVal.id != null){
                // Loojup SE 
                if(newVal.suratEdaran.length != 0){
                    this.seWarnaBatu = newVal.suratEdaran

                    for(var se of this.seWarnaBatu){
                        if(se.isViewSE == "false"){
                            this.pdfReadWarnaBatu = false
                        }
                    }
                }else{
                    this.seWarnaBatu = null
            }
        }
        },

        "input.emas.capEmas" : function(newVal){
            this.fotoCapEmas = []
          //Lookup Jenis Kemasan Emas
          if(newVal == null) {return}

          this.$axios.get(`cap-emas/photos?id=${newVal.id}`).then(response => {
                this.fotoCapEmas = response.data
            })
        },

        "input.nilaiPinjaman": function (newValue) {

        const result = newValue.replace(/\D/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ".");

        this.$nextTick(() => this.input.nilaiPinjaman = result)

        if (this.input.metodeGadai == 'angsuran' && !this.$helper.isNullOrEmpty(this.input.tenor)) {
            this.showJadwalAngsuran = false
            clearTimeout(this._angsuranTimer)
            this._angsuranTimer = setTimeout(() => {
                this.getSimulasiAngsuran()
            }, 500)
        }

        },

        "tanggalPajak": function(newDate) {
            this.masaBerlaku(newDate)
        },
        "input.kendaraan.kondisi": function() {
            console.log("tanggal", this.tanggalPajak);
            
        this.masaBerlaku(this.tanggalPajak)
        
    },
    "tabIndex" : function(newVal) {
        this.handleTabChange(newVal);
    }
    },

    created() {
        this.init();
    },
}
</script>


<style scoped>
.skeleton-value {
  height: 18px;
  width: 70%;
}
.cursor-pointer {
  cursor: pointer;
}

.footer-btn-taksiran-gadai {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.footer-btn-simulasi-gadai-emas {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}
</style>